<template>
  <div id="oaExamineAudit">
    <!-- 主区域弹框 -->
    <div v-if="dialogAuditVisible">
      <component
        v-bind:is="componentType"
        :title="AuditData ? AuditData.appname : ''"
        v-model="dialogAuditVisible"
        :destroy-on-close="true"
        :show-close="false"
        :close-on-click-modal="false"
        :class="[
          pdheight === 'auto'
            ? 'application-routing-dialog-all dialog-height-auto'
            : 'application-routing-dialog-all',
          appAgentConfig && Object.keys(appAgentConfig).length > 0
            ? 'chat-path-dialog'
            : ''
        ]"
        :fullscreen="routingFlowshow"
        :top="routingFlowshow ? '0' : '8.9vh'"
        :width="widthComp"
        :size="diaSize"
        :with-header="false"
        @close="$emit('close')"
        append-to-body
      >
        <!-- 顶部栏 -->
        <el-row class="top-class" v-if="AuditData && !isNewPage && pageSetPopupStyle === 'default'">
          <!-- 内容 -->
          <el-col :span="24">
            <div class="dialog-top">
              <div style="padding-left: 20px">
                <template v-if="isTime === 0">
                  {{ auditDataName }}
                  <span
                    v-if="AuditData.utype == 3"
                    style="
                      border-radius: 4px;
                      border: 1px solid #c2c2c2;
                      padding: 2px 10px;
                      margin-left: 5px;
                      font-size: 14px;
                      color: #999999;
                    "
                  >
                    <!-- <template v-if="AuditData.utype==1">教工</template> -->
                    <template>超级管理员</template>
                    <!-- <template v-else>学生 </template> -->
                  </span>
                  {{ formatTimestamp(AuditData.approving.orders) }}
                  发起
                  {{
                    AuditData.appname
                      ? AuditData.appname.length > 12
                        ? AuditData.appname.substring(0, 12) + "..."
                        : AuditData.appname
                      : "&nbsp;"
                  }}
                </template>
              </div>
              <div class="apply-right">
                <!-- 状态  官网不要显示审批状态-->
                <div v-if="AuditList && AuditList.length !== 1 && !websiteSwitch">
                  <div class="fRight">
                    <p class="status-class">
                      <span
                        v-if="AuditData.approving.status == 0"
                        style="color: #eb9c19"
                      >
                        <i class="icon iconfont icon-chulizhong-"></i>{{ getStatus0 }}
                      </span>
                      <span
                        v-else-if="AuditData.approving.status == 1"
                        style="color: #19b359"
                      >
                        <i class="icon iconfont icon-tongguo-"></i>{{ getStatus1 }}
                      </span>
                      <span
                        v-else-if="AuditData.approving.status == 2"
                        style="color: #e47470"
                      >
                        <i class="icon iconfont icon-jujue-"></i>{{ getStatus2 }}
                      </span>
                      <span
                        v-else-if="AuditData.approving.status == 3"
                        style="color: #666666"
                      >
                        <i class="icon iconfont icon-chehui"></i>撤回
                      </span>
                    </p>
                  </div>
                </div>
                <!-- 数据对比 -->
                <div
                  v-if="
                    AuditData.approving &&
                    AuditData.approving.cochain === 2 &&
                    blockchainShow === true &&
                    blockchainReadyShow === false
                  "
                >
                  <div class="rigntBtn active-hover" @click="goPage">
                    <!-- <i class="icon iconfont icon-duibi"></i> -->
                    <div
                      :class="blockchainStuts === 1 ? 'ballShow' : 'ballShow red'"
                    ></div>
                    <p>数据对比</p>
                  </div>
                </div>
                <div v-if="isAi && aiStatus" class="rigntBtn active-hover" :style="{color: isAi === 1 ? '#4e86ff' : ''}"
                @click="upAi(isAi === 1 ? 2 : 1)">
                  <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/ai.png" style="width:25px;height:25px;vertical-align: inherit;margin-right:4px;" />
                  AI小易
                </div>
                <!--流程隐藏显示 官网不显示流程-->
                <div
                  class="rigntBtn active-hover"
                  @click="onFlowshow"
                  v-if="showFlowButton()"
                >
                  <el-icon style="float:left;margin:15px 3px 0 0;"><View /></el-icon>
                  {{ getFlowShowText() }}
                </div>
                <div class="rigntBtn">
                  <!-- 删除 -->
                  <!-- <span v-if="sDetel" style="margin-right:5px;" @click="delDataFun" class="active-hover">
                    <i class="iconfont icon-shanchu" style="color:#e5283f;" />
                  </span>
                  <span v-if="sDetel" title="编辑" style="margin-right:5px;" @click="resubmit(AuditData)" class="active-hover">
                    <i class="iconfont icon-bianji" style="color:#e5283f;" />
                  </span> -->
                  <!-- 查看日志 -->
                  <span v-if="sMyoplog" style="margin-right:5px;"
                      @click="getLog"
                      class="active-hover">
                    <i class="iconfont icon-chakanxiangqing1 todo-icon-color" style="color:#999;" />
                  </span>
                  <!-- 二维码 -->
                  <span style="margin-right:5px;" title="数据二维码" v-if="oqrcore">
                    <el-dropdown @command="onQrcodeCommand">
                      <span class="el-dropdown-link active-hover">
                        <i class="iconfont icon-erweima- qrcode"></i>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <template v-if="qrcodetypes">
                            <el-dropdown-item :command="1" v-if="qrcodetypes.includes(2)"
                            >生成小程序端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item :command="2" v-if="qrcodetypes.includes(3)"
                            >生成小程序端动态二维码</el-dropdown-item
                            >
                            <el-dropdown-item :command="1" v-if="qrcodetypes.includes(4)"
                            >生成H5端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item :command="2" v-if="qrcodetypes.includes(5)"
                            >生成H5端动态二维码</el-dropdown-item
                            >
                          </template>
                          <template v-else>
                            <el-dropdown-item :command="1" v-if="oqrcore === 1 || oqrcore === 2"
                            >生成小程序端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item :command="2" v-if="oqrcore === 1 || oqrcore === 3"
                            >生成小程序端动态二维码</el-dropdown-item
                            >
                            <el-dropdown-item :command="1" v-if="oqrcore === 1 || oqrcore === 4"
                            >生成H5端静态二维码</el-dropdown-item
                            >
                            <el-dropdown-item :command="2" v-if="oqrcore === 1 || oqrcore === 5"
                            >生成H5端动态二维码</el-dropdown-item
                            >
                          </template>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </span>
                  <!-- 二维码 -->
                  <span style="margin-right:5px;" title="查看二维码" v-if="lookqrcode">
                    <el-dropdown @command="onLookQrcodeCommand">
                      <span class="el-dropdown-link active-hover">
                        <i class="iconfont icon-erweima- qrcode"></i>
                      </span>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <template v-if="lookqrcode">
                            <el-dropdown-item :command="1" v-if="lookqrcodetypes.includes(1)"
                            >生成小程序查看二维码</el-dropdown-item
                            >
                            <el-dropdown-item :command="2" v-if="lookqrcodetypes.includes(2)"
                            >生成H5端查看二维码</el-dropdown-item
                            >
                          </template>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
                  </span>
                  <!-- 官网不要打印的东西 -->
                  <template v-if="!websiteSwitch">
                    <!-- 默认打印 -->
                    <template v-if="!isCustomPrint">
                      <span
                        style="margin-right:5px;"
                        class="active-hover"
                        @click="auditPrinting"
                        v-if="panduanShow() && blockchainReadyShow === false && isShowDefaultPrint"
                      >
                        <i class="icon iconfont icon-dayin"></i>
                        <!--                打印-->
                      </span>
                    </template>
                    <!-- 自定义打印 -->
                    <template v-else-if="panduanShow() && blockchainReadyShow === false" >
                      <el-dropdown
                        v-if="printConfig.length > 1 || isShowDefaultPrint"
                        @command="customPrinting"
                        trigger="click">
                          <span
                            style="margin-right:5px;"
                            class="active-hover el-dropdown-link"
                          >
                            <i class="icon iconfont icon-dayin"></i>
                          </span>
                          <template #dropdown>
                            <el-dropdown-menu>
                            <el-dropdown-item v-for="(item, index) in printConfig" :command="index" :key="index">
                              {{ item.canvasName }}
                            </el-dropdown-item>
                            <el-dropdown-item command="default" v-if="isShowDefaultPrint">
                              默认
                            </el-dropdown-item>
                          </el-dropdown-menu>
                          </template>
                      </el-dropdown>
                      <span
                        v-else
                        @click="customPrinting(0)"
                        style="margin-right:5px;"
                        class="active-hover el-dropdown-link"
                      >
                        <i class="icon iconfont icon-dayin"></i>
                      </span>
                    </template>
                  </template>
                  <span class="active-hover" style="margin-right:5px;" @click="routingFlowshow = !routingFlowshow">
                    <i v-show="!routingFlowshow" class="iconfont icon-fangda2" style="font-size: 14px;" />
                    <i v-show="routingFlowshow" class="iconfont icon-suoxiao1" style="font-size: 14px;" />
                  </span>
                  <!-- 关闭 -->
                  <span class="active-hover" @click="closeDialog()">
                    <i class="icon iconfont icon-shanchu3"></i>
                  </span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- 表单区域内容 -->
        <!-- :style="{ height: dialogInfo.dialogHeight }" -->
        <template v-if="viewDetailFun === 'app-comment'">
          <div class="oaExamineRight" style="background-color: #F0F2F5; height: 77vh;" v-if="AuditList && AuditList.length > 0" :class="baseSet && baseSet.flowshow && baseSet.flowshow.width ? 'ctoAllArea-flow' : ''">
            <div class="ctoArray-class" style="height: 100%;">
              <template v-if="!baseSet || !baseSet.flowshow || baseSet.flowshow.type === 'merge'">
                <el-scrollbar v-if="isOpenFlow" class="el-menu-scrollbar__wrap" style="height: 100%">
                  <div>
                    <div class="process">
                      <el-timeline style="padding: 15px">
                        <template v-for="(value, indeex) in AuditList" :key="value.id">
                          <el-timeline-item :class="['timeline-blue', ('timeline-' + statusObj[indeex === 0 && value.status === 0 ? 1 : value.status])]" :icon="value.status !== 0 || indeex === 0 && value.status === 0 ? 'el-icon-check' : ''">
                            <el-card
                              :body-style="{
                                padding: '13px 14px',
                                position: 'relative',
                              }"
                            >
                              <!-- <i class="iconfont icon-renyuanfuzhi6 icon-timeLine-user" /> -->
                              <el-row>
                                <!-- 用户名 -->
                                <el-col :span="24" style="display:flex;align-items:center;">
                                  <span class="name">{{ value.user ? value.user.realname : "" }}</span>
                                  <div class="orgname" v-if="value.user && value.user.orgname">
                                    <template v-for="(orgne, index) in orgneFun(value.user.orgname)">
                                      <span v-if="!orgne.uservisible && orgne.uservisible !== 0 || orgne.uservisible === 1" v-show="index < 2" :key="orgne.id">{{ orgne.name || orgne }}</span>
                                    </template>
                                  </div>
                                </el-col>
                                <el-col
                                  :span="24"
                                  class="urgent-class"
                                  v-if="
                                  reminder && (
                                    indeex !== 0 &&
                                    Number(AuditList[0].status) === 0 &&
                                    AuditData.userapprovingId > 0 &&
                                    AuditData &&
                                    !AuditData.userccappId &&
                                    AuditData.type !== 9 &&
                                    value.status == '0' &&
                                    value.type == 1 &&
                                    value.way != 3)
                                  "
                                >
                                  <span class="blueBtn"
                                    title="催办一下，TA会收到消息推送"
                                    @click=" urgent( value.approuser || [value.user], value.userapprovingId ) " >催办</span
                                  >
                                </el-col>
                                <div style="width:100%;padding-top: 10px">
                                  <el-col :span="16" class="AuditList-head">
                                    <template v-if="value.way && value.way == 4">
                                      <span class="sponsor">
                                        {{ approvalProcess4(value, buttonList) }}
                                      </span>
                                    </template>
                                    <template v-else-if="value.way && value.way == 3">
                                      <span class="yellow" v-if="value.way == 3">
                                        {{ launchdataPl }}
                                      </span>
                                    </template>
                                    <template v-else>
                                      <template v-if="value.type == 0">
                                        <span
                                          class="recall"
                                          v-if="value.status == 3"
                                          >{{ launchdataChH }}</span
                                        >
                                        <span
                                          class="sponsor"
                                          :style="
                                            launchdata === '发起'
                                              ? 'color:#4e86ff;'
                                              : ''
                                          "
                                          v-else
                                          >{{ launchdata }}</span
                                        >
                                        <!--type=0并且status:4重新提交，status为3 是撤回-->
                                      </template>
                                      <template v-else>
                                        <span
                                          class="success"
                                          v-if="value.status == '1' && value.way != 3">
                                          {{ approvalProcess2(value, buttonList) }}
                                        </span>
                                        <span
                                          class="approval-stat"
                                          v-else-if="(value.status == '0' && value.way != 3) || value.status == '4'">
                                          {{ approvalProcess1(value, buttonList) }}
                                        </span>
                                        <span
                                          class="pass"
                                          v-else-if="value.status == '2' && value.way != 3">
                                          {{ approvalProcess3(value, buttonList) }}
                                        </span>
                                        <span v-else class="def-d">待办</span>
                                      </template>
                                    </template>
                                    <span
                                      @click="approuserMore(value.approuser)"
                                      :class="['blueBtn', getIconBackFlow(value)]"
                                      v-if="value.approuser && value.approuser.length > 1"
                                      ><i class="iconfont icon-a-zu181" /></span>
                                    <span v-if="isTime === 0 && (value.status != 0 && value.status !== -1 || indeex === 0)" class="time">
                                      <i class="iconfont icon-a-zu148" />
                                      {{ formatTimestamp(value.ctime) }}
                                    </span>
                                  </el-col>
                                </div>
                                <el-col v-if="value.approuser && value.approuser.length > 1" :span="24" style="padding-top: 14px;">
                                  <span class="span-text">多人处理</span>
                                </el-col>
                                <el-col
                                  :span="24"
                                  v-if="value.note || value.comment"
                                >
                                  <div class="comment-class">
                                    {{ value.note }}{{ value.comment }}
                                  </div>
                                </el-col>
                                <el-col
                                  :span="24"
                                  v-if="value.sign"
                                >
                                  <div class="sign-class">
                                    签名：
                                    <img :src="$imgurl+value.sign+'?accesstoken='+token" alt="">
                                  </div>
                                </el-col>
                                <!-- 附件 -->
                                <el-col
                                  :span="24"
                                  v-if="
                                    (value.notefile &&
                                      Array.isArray(value.notefile)) ||
                                    (value.notefile && value.notefile.length > 2)
                                  "
                                >
                                  <div
                                    class="notefile-class"
                                    v-for="file in JSON.parse(value.notefile)"
                                    :key="file.id"
                                  >
                                    <p @click="showNotefile(file)">
                                      <i
                                        class="iconfont icon-fujian"
                                        style="font-size: 14px; font-weight: normal"
                                      />
                                      {{ BatchFileName(file) }}
                                    </p>
                                    <p class="noteicon">
                                      <a
                                          @click="downNotefile(file)"
                                        href="#"
                                        class="icon iconfont icon-xiazai2x"
                                      ></a>
                                    </p>
                                  </div>
                                </el-col>
                              </el-row>
                            </el-card>
                          </el-timeline-item>
                        </template>
                        <el-timeline-item
                          color="#fff"
                          size="large"
                          class="timeline-red timeline-end"
                          icon="icon-end"
                          v-if="AuditData && AuditData.approving.status != 0"
                        >
                          <p style="color: #738390; padding-top: 8px">流程结束</p>
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </div>
                  <!--以下为告知-->
                  <el-row v-if="isCustom && AuditList && Number(AuditList[0].cctotal) !== 0">
                    <el-col :span="24">
                      <p class="title">通知对象</p>
                    </el-col>
                    <el-col :span="12" style="padding: 15px; color: #999">
                      总共{{ AuditList[0].cctotal }}人，{{
                        AuditList[0].ccread
                      }}人已读
                    </el-col>
                    <el-col :span="12" style="text-align: right; padding: 15px">
                      <span class="blueBtn" @click="lookUp(1)">查看全部</span>
                    </el-col>
                  </el-row>
                </el-scrollbar>
                <div v-else style="display: flex;width: 100%;height: 100%;align-items: center;justify-content: center;">未开启流程</div>
              </template>
              <flowShow v-else :isOpenFlow="isOpenFlow" :flowshow="baseSet.flowshow" :AuditList="AuditList" :reminder="reminder" :isTime="isTime" :buttonList="buttonList" :opencomment="opencomment" :AuditData="AuditData" :ruleList="ruleList" @showNotefile="showNotefile" @downNotefile="downNotefile" @urgent="urgents" @approuserMore="approuserMore" @subComment="subComment" />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="oaExamineAllArea" :style="{
            height: isNewPage || pageSetPopupStyle !== 'default' ? '100%' : 'calc(100% - 44px)'
          }" v-if="blockchainReadyShow === false" >
            <!-- 表单区域内容 -->
            <!-- :style="flowshow === 1 ? 'width:73%' : 'width:100%'" -->
            <div
              class="oaExamineLeft"
              :style="getLeftWidth()"
            >
              <!-- 简约模式的按钮关闭-->
              <span class="close-dialog" @click="closeDialog" v-if="pageSetPopupStyle !== 'default'">
                <i class="icon iconfont icon-shanchu3"></i>
              </span>
              <el-scrollbar
                class="oaExamineAuditBox el-menu-scrollbar__wrap"
                :class="{ 'bor-color': isborcolor }"
                v-loading="fullScreenLoading"
                element-loading-text="数据加载中"
                :style="getBack(themeConfig)"
              >
                <div class="auditBox" v-if="AuditData">
                  <!-- 数据展示 -->
                  <div class="form-main-class">
                    <!--这里加列表  ctoArray -->
                    <div v-if="isNews">
                      <div class="app-name-class2">
                        {{ showNewsTitle }}
                      </div>
                      <detailCount
                        v-if="AuditData"
                        ref="detailCount"
                        :isComment="isComment"
                        :isNews="true"
                        :isNewPage="false"
                        :AuditData="AuditData"
                        :skey="skey"
                        :AuditList="AuditList"
                        :otherConfig="otherConfig"
                        :subTitle="baseSet.subTitle || []"
                        :formdata="formdata"
                        @comment="review"
                        @open-to-list="lookUp(1)"
                      />
                    </div>
                    <!-- 主题设计 -->
                    <theme
                      v-if="isOpenTheme"
                      :themeConfig="themeConfig"
                    />
                    <!-- 自定义页面的导航 -->
                    <customPageNav
                      v-if="customCanvasLength > 1"
                      :navType="pageSet.navType"
                      :currentIndex="customCanvasIndex"
                      :canvasLength="customCanvasLength"
                      :canvasConfig="pageSet.configList"
                    />
                    <el-form
                      v-show="!isCustom"
                      :model="ruleForm"
                      ref="ruleForm"
                      label-width="160px"
                      :label-position="'top'"
                      class="demo-ruleForm form-class"
                    >
                    <!-- 默认 -->
                      <template v-if="!websiteSwitch && AuditData.approving">
                        <widget-one-layer
                        v-model:ruleListChild="ruleList"
                        v-model:approvalId="AuditData.approving.approvalId"
                        v-model:approvingId="AuditData.approvingId"
                        :formdata="formdata"
                        :opensafe="opensafe"
                        :othersObj="othersObj"
                        :associationVisible="associationVisible"
                        :layout="layout"
                        :baseSet="baseSet"
                        :tipsize="tipsize"
                        :pdwidth="pdwidth"
                        :themeConfig="themeConfig"
                        :AuditList="AuditList"
                        :isNews="isNews"
                        :customData="customData"
                        :isFiexdCanvas="isFiexdCanvas"
                        :fiexdCanvasInfo="fiexdCanvasInfo"
                        ref="widgetOneLayerRef"
                        @previewPictureImg="previewPicture"
                        @record="upRecord"
                        @widgetOneLayerEmit="widgetOneLayerEmitFun"
                        @setAi="setAi">
                          <!-- <el-col :span="layout == 4 || layout === 14 ? 6 : layout == 2 || layout === 12 ? 12 : 24"
                            v-if="linkconfig && linkconfig.open"
                            class="link-config">
                            <el-form-item label="选择模式" title="选择模式">
                              <el-radio v-model="formdata.linktype" :label="0">打开平台页面</el-radio>
                              <el-radio v-model="formdata.linktype" :label="1">直接打开链接</el-radio>
                            </el-form-item> -->
                            <!-- <span class="link-config-title">选择模式:</span>
                            <span class="link-config-but" v-if="linkconfig.terrace">打开平台页面</span>
                            <span class="link-config-but" v-if="linkconfig.link" @click="openLink(linkconfig)">直接打开链接</span> -->
                          <!-- </el-col> -->
                        </widget-one-layer>
                      </template>
                      <web-site-widget-one-layer
                        v-if="websiteSwitch"
                        v-model:ruleListChild="ruleList"
                        :approvalId="AuditData && AuditData.approving && AuditData.approving.approvalId"
                        :approvingId="AuditData && AuditData.approvingId"
                        :formdata="formdata"
                        :othersObj="othersObj"
                        :associationVisible="associationVisible"
                        :layout="layout"
                        :isNews="isNews"
                        :isFiexdCanvas="isFiexdCanvas"
                        :fiexdCanvasInfo="fiexdCanvasInfo"
                        ref="webSiteWidgetOneLayerRef"
                        @previewPictureImg="previewPicture"
                        @record="upRecord"
                        @widgetOneLayerEmit="widgetOneLayerEmitFun">
                      </web-site-widget-one-layer>
                      <!--以下为告知-->
                      <div class="cto-list" v-if="!isNews && ctoShow && AuditList && Number(AuditList[0].cctotal) !== 0">
                        <el-row
                          class="cto-row"
                          :gutter="40"
                          type="flex"
                          style="flex-wrap: wrap;"
                        >
                          <el-col
                            :span="24"
                          >
                            <div class="inner" :class="layout ==11 || layout ==12 || layout === 14 ? 'inner' : 'inner inner-layout'">
                              <span class="title">通知对象</span>
                              <div class="list-detail">
                                <span
                                  class="blueBtn"
                                  @click="lookUp(1)"
                                >总共{{ AuditList[0].cctotal }}人，已读{{ AuditList[0].ccread }}人，未读{{ AuditList[0].cctotal - AuditList[0].ccread }}人</span>
                                <div
                                  class="list-box"
                                >
                                <el-tag type="primary" v-for="item in checkedFlowArr" :key="item.organizationId" style="margin:3px">{{item.name}}</el-tag>
                                <el-tag type="primary" v-for="item in checkedRoleArr" :key="item.roleId" style="margin:3px">{{item.name}}</el-tag>
                                <el-tag type="primary" v-for="item in checkedGroupArr" :key="item.folderId" style="margin:3px">{{item.realname || item.name}}</el-tag>
                                <el-tag type="primary" v-for="item in checkedArrUser" :key="item.userId" style="margin:3px">{{item.realname || item.name}}</el-tag>
                                </div>
                              </div>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </el-form>
                    <!-- 自定义 -->
                    <customWidgetOneLayer
                      v-if="isCustom && !isHtml"
                      :tableData="formdata"
                      :skey="skey"
                      :ruleListChild="ruleList"
                      :workshopFormdata="workshopFormdata"
                      :detailConfig="pageSet"
                      :popupStyle="pageSetPopupStyle"
                      :commentData="{AuditList,checkedFlowArr,checkedRoleArr,checkedArrUser,checkedGroupArr}"
                      :customCanvasIndex="customCanvasIndex"
                      @close="closeDialog"
                      @lookUp="(e)=>{lookUp(e)}"
                      @blockchain-btn="$emit('blockchain-btn', AuditData)"
                      @dataArchiving-btn="$emit('dataArchiving-btn', AuditData)"
                      @edit-btn="() => { $emit('edit-btn', AuditData); closeDialog() }"
                      @del-btn="() => { $emit('del-btn', AuditData.approvingId); closeDialog() }"
                      @app-print="(printId) => { customPrinting(-1, printId) }"
                    ></customWidgetOneLayer>
                    <div class="input-page" v-if="isHtml">
                      <iframe class="input-page-container" ref="htmlIframe" :src="htmlInfo.url"></iframe>
                    </div>
                  </div>
                </div>
              </el-scrollbar>
              <!-- 底部按钮 -->
              <div
                class="examine-footer"
                style="height: auto;"
                v-if="
                  ((AuditData &&
                    AuditData.userapprovingId > 0 &&
                    AuditData &&
                    !AuditData.userccappId &&
                    !AuditData.guanyuwode &&
                    AuditData.type != 9) ||
                  (AuditData && AuditData.userccappId && comment === 1)) &&
                  pageSetPopupStyle === 'default'
                "
              >
                <oaExamineCommentNew
                  v-if="commentNewStatus === 1 && isInit && AuditData"
                  ref="oaExamineCommentNew"
                  :templateDate="AuditData.approvingFormdata"
                  :templateModify="ruleList"
                  @resetHeight="commentHeight = $event"
                  @retSubComment="subComment"
                  @loadingFun="loadingFun"
                  element-loading-text="数据加载中"
                ></oaExamineCommentNew>
                <div class="footer-box">
                  <div class="fiexd-canvas-bottom" v-if="customCanvasLength > 1">
                    <div :class="[customCanvasIndex === 0 ? 'disabled-btn' : 'clickable-btn']"
                      @click="customCanvasChange('prve')">上一步</div>
                    <div :class="[customCanvasIndex === customCanvasLength - 1 ? 'disabled-btn' : 'clickable-btn']"
                      @click="customCanvasChange('next')">下一步</div>
                  </div>
                  <detailCount ref="detailCount" v-if="this.appProperty.length > 0 && !this.isNews" @comment="review" :isComment="isComment" :AuditData="AuditData" :otherConfig="otherConfig" :skey="skey" :AuditList="AuditList" @open-to-list="lookUp(1)" />
                  <!-- <div class="footerBtn" @click="review" v-if="isComment">
                    <i class="icon iconfont icon-pinglun"></i> 评论
                  </div> -->
                  <div class="footerBtn" v-if="sUpdate && !(AuditData.type == 1 && AuditData.status == 0)">
                    <el-button class="el-danger-btn" type="primary" @click="editDataFn(AuditData, true)">编辑</el-button>
                  </div>
                  <template
                    v-if="
                      AuditData &&
                      AuditData.userapprovingId > 0 &&
                      AuditData &&
                      !AuditData.userccappId &&
                      !AuditData.guanyuwode &&
                      AuditData.type != 9
                    "
                  >
                    <template v-if="AuditData.type == 1 && AuditData.status == 0">
                      <!--            <div class="footerBtn" @click="review"><i class="icon iconfont icon-pinglun"></i> 评论</div>-->
                    <!-- 测试说，不区分转办和流转   && Number(AuditData.mode) === 1 || Number(AuditData.mode) !== 1 -->
                      <div v-if="transfer" class="footerBtn" @click="flowBtn(AuditData.mode)">
                        <i class="iconfont icon-zhuanfa"></i>
                        {{ Number(AuditData.mode) === 1 ? "转办" : "流转" }}
                      </div>
                      <div
                        class="footerBtn"
                        v-for="(list, index) in buttonListComputed"
                        :key="list.id"
                      >
                        <el-button
                          :type="index == 1 ? 'danger' : 'yeprimary'"
                          :plain="index == 1 ? true : false"
                          v-if="index < 2 && list"
                          @click="auditBtn(index + 1, list)"
                          >{{ list }}</el-button
                        >
                      </div>
                    </template>

                    <!--我已办理-->
                    <template v-if="AuditData.type == 1 && AuditData.status != 0">
                      <!--            <div class="footerBtn" @click="review"><i class="icon iconfont icon-pinglun"></i> 评论</div>-->
                      <div class="footerBtn" v-if="pass === 1" @click="flowBtn(9)">
                        <i class="iconfont icon-zhuanfa"></i> 传阅
                      </div>
                    </template>

                    <!--我发起的-->
                    <template v-if="AuditData.type == 0">
                      <!--            <div class="footerBtn" @click="review"><i class="icon iconfont icon-pinglun"></i> 评论</div>-->
                      <div
                        class="footerBtn"
                        @click="flowBtn(9)"
                        v-if="
                          Number(AuditData.status) !== 3 &&
                          Number(AuditData.status) !== 2 &&
                          pass === 1
                        "
                      >
                        <i class="iconfont icon-zhuanfa"></i> 传阅
                      </div>
                      <template v-if="AuditData.status != 1">
                        <div
                          class="footerBtn"
                          v-if="AuditData.status == 3 || AuditData.status == 2"
                        >
                          <el-button class="staingBtn" @click="resubmit(AuditData)"
                            >重新编辑</el-button
                          >
                        </div>
                        <div class="footerBtn" v-else>
                          <el-button
                            type="primary"
                            @click="cancel(3, '撤销')"
                            :disabled="AuditData.status == 0 ? false : true"
                            >撤 销</el-button
                          >
                        </div>
                      </template>
                    </template>
                  </template>
                  <template v-if="sDetel && !(AuditData.type == 1 && AuditData.status == 0)">
                    <div class="footerBtn">
                      <el-button plain class="el-danger-btn" style="margin-right: 10px;margin-top: 0;" type="danger" @click="delDataFun">删除</el-button>
                    </div>
                  </template>
                </div>
              </div>
            </div>

            <!-- ai -->
            <div v-if="(isAi === 1 || isAi === 3) && aiStatus" class="oaExamineRight ctoAllArea-ai" :style="getAiAreaStyle()">
              <div class="resize-handle" @mousedown="startResize"></div>
              <chat-box v-if="isAi === 1" :robotConfig="robotConfig.view" :modelConfig="robotConfig.view && robotConfig.view.robot ? robotConfig.view.robot : []" :approvalId="AuditData.approving.approvalId" :approvingId="AuditData.approvingId || AuditData.approving.approvingId" :appfile="appfile" :formdata="formdata" :ruleList="ruleList" :appCustomData="appCustomData" :appAgentConfig="appAgentConfig" @textInsert="textInsert" @close="closeDialog" />
              <draw-box v-else-if="isAi === 3" />
            </div>

            <!-- 流程区域内容 -->
            <div class="oaExamineRight" v-if="AuditList && AuditList.length > 0 && flowshow===1" :class="baseSet && baseSet.flowshow && baseSet.flowshow.width ? 'ctoAllArea-flow' : ''" :style="getFlowWidth()">
              <div class="ctoArray-class">
                <!--以下为处理流程-->
                <template v-if="!baseSet || !baseSet.flowshow || baseSet.flowshow.type === 'merge'">
                  <el-scrollbar v-if="isOpenFlow" class="el-menu-scrollbar__wrap" style="height: 100%">
                    <div>
                      <!-- <p class="title">处理流程</p> -->
                      <div class="process">
                        <el-timeline style="padding: 15px">
                          <template v-for="(value, indeex) in AuditList" :key="value.id">
                            <el-timeline-item :class="['timeline-blue', ('timeline-' + statusObj[indeex === 0 && value.status === 0 ? 1 : value.status])]" :icon="value.status !== 0 || indeex === 0 && value.status === 0 ? 'el-icon-check' : ''">
                              <el-card
                                :body-style="{
                                  padding: '13px 14px',
                                  position: 'relative',
                                }"
                              >
                                <!-- <i class="iconfont icon-renyuanfuzhi6 icon-timeLine-user" /> -->
                                <el-row>
                                  <!-- 用户名 -->
                                  <el-col :span="24" style="display:flex;align-items:center;">
                                    <span class="name">{{ value.user ? value.user.realname : "" }}</span>
                                    <div class="orgname" v-if="value.user && value.user.orgname">
                                      <template v-for="(orgne, index) in orgneFun(value.user.orgname)">
                                        <span v-if="!orgne.uservisible && orgne.uservisible !== 0 || orgne.uservisible === 1" v-show="index < 2" :key="orgne.id">{{ orgne.name || orgne }}</span>
                                      </template>
                                    </div>
                                  </el-col>
                                  <el-col
                                    :span="24"
                                    class="urgent-class"
                                    v-if="
                                    reminder && (
                                      indeex !== 0 &&
                                      Number(AuditList[0].status) === 0 &&
                                      AuditData.userapprovingId > 0 &&
                                      AuditData &&
                                      !AuditData.userccappId &&
                                      AuditData.type !== 9 &&
                                      value.status == '0' &&
                                      value.type == 1 &&
                                      value.way != 3)
                                    "
                                  >
                                    <span class="blueBtn"
                                      title="催办一下，TA会收到消息推送"
                                      @click=" urgent( value.approuser || [value.user], value.userapprovingId ) " >催办</span
                                    >
                                  </el-col>
                                  <div style="width:100%;padding-top: 10px">
                                    <el-col :span="16" class="AuditList-head">
                                      <template v-if="value.way && value.way == 4">
                                        <span class="sponsor">
                                          {{ approvalProcess4(value, buttonList) }}
                                        </span>
                                      </template>
                                      <template v-else-if="value.way && value.way == 3">
                                        <span class="yellow" v-if="value.way == 3">
                                          {{ launchdataPl }}
                                        </span>
                                      </template>
                                      <template v-else>
                                        <template v-if="value.type == 0">
                                          <span
                                            class="recall"
                                            v-if="value.status == 3"
                                            >{{ launchdataChH }}</span
                                          >
                                          <span
                                            class="sponsor"
                                            :style="
                                              launchdata === '发起'
                                                ? 'color:#4e86ff;'
                                                : ''
                                            "
                                            v-else
                                            >{{ launchdata }}</span
                                          >
                                          <!--type=0并且status:4重新提交，status为3 是撤回-->
                                        </template>
                                        <template v-else>
                                          <span
                                            class="success"
                                            v-if="value.status == '1' && value.way != 3">
                                            {{ approvalProcess2(value, buttonList) }}
                                          </span>
                                          <span
                                            class="approval-stat"
                                            v-else-if="(value.status == '0' && value.way != 3) || value.status == '4'">
                                            {{ approvalProcess1(value, buttonList) }}
                                          </span>
                                          <span
                                            class="pass"
                                            v-else-if="value.status == '2' && value.way != 3">
                                            {{ approvalProcess3(value, buttonList) }}
                                          </span>
                                          <span v-else class="def-d">待办</span>
                                        </template>
                                      </template>
                                      <span
                                        @click="approuserMore(value.approuser)"
                                        :class="['blueBtn', getIconBackFlow(value)]"
                                        v-if="value.approuser && value.approuser.length > 1"
                                        ><i class="iconfont icon-a-zu181" /></span>
                                      <span v-if="isTime === 0 && (value.status != 0 && value.status !== -1 || indeex === 0)" class="time">
                                        <i class="iconfont icon-a-zu148" />
                                        {{ formatTimestamp(value.ctime) }}
                                      </span>
                                    </el-col>
                                  </div>
                                  <el-col v-if="value.approuser && value.approuser.length > 1" :span="24" style="padding-top: 14px;">
                                    <span class="span-text">多人处理</span>
                                  </el-col>
                                  <el-col
                                    :span="24"
                                    v-if="value.note || value.comment"
                                  >
                                    <div class="comment-class">
                                      {{ value.note }}{{ value.comment }}
                                    </div>
                                  </el-col>
                                  <el-col
                                    :span="24"
                                    v-if="value.sign"
                                  >
                                    <div class="sign-class">
                                      签名：
                                      <img :src="$imgurl+value.sign+'?accesstoken='+token" alt="">
                                    </div>
                                  </el-col>
                                  <!-- 附件 -->
                                  <el-col
                                    :span="24"
                                    v-if="
                                      (value.notefile &&
                                        Array.isArray(value.notefile)) ||
                                      (value.notefile && value.notefile.length > 2)
                                    "
                                  >
                                    <div
                                      class="notefile-class"
                                      v-for="file in JSON.parse(value.notefile)"
                                      :key="file.id"
                                    >
                                      <p @click="showNotefile(file)">
                                        <i
                                          class="iconfont icon-fujian"
                                          style="font-size: 14px; font-weight: normal"
                                        />
                                        {{ BatchFileName(file) }}
                                      </p>
                                      <p class="noteicon">
                                        <a
                                          @click="downNotefile(file)"
                                          href="#"
                                          class="icon iconfont icon-xiazai2x"
                                        ></a>
                                      </p>
                                    </div>
                                  </el-col>
                                </el-row>
                              </el-card>
                            </el-timeline-item>
                          </template>
                          <el-timeline-item
                            color="#fff"
                            size="large"
                            class="timeline-red timeline-end"
                            icon="icon-end"
                            v-if="AuditData && AuditData.approving.status != 0"
                          >
                            <p style="color: #738390; padding-top: 8px">流程结束</p>
                          </el-timeline-item>
                        </el-timeline>
                      </div>
                    </div>
                    <!--以下为告知-->
                    <el-row v-if="isCustom && AuditList && Number(AuditList[0].cctotal) !== 0">
                      <el-col :span="24">
                        <p class="title">通知对象</p>
                      </el-col>
                      <el-col :span="12" style="padding: 15px; color: #999">
                        总共{{ AuditList[0].cctotal }}人，{{
                          AuditList[0].ccread
                        }}人已读
                      </el-col>
                      <el-col :span="12" style="text-align: right; padding: 15px">
                        <span class="blueBtn" @click="lookUp(1)">查看全部</span>
                      </el-col>
                    </el-row>
                  </el-scrollbar>
                  <div v-else style="display: flex;width: 100%;height: 100%;align-items: center;justify-content: center;">未开启流程</div>
                </template>
                <flowShow v-else :isOpenFlow="isOpenFlow" :flowshow="baseSet.flowshow" :AuditList="AuditList" :reminder="reminder" :isTime="isTime" :buttonList="buttonList" :opencomment="opencomment" :AuditData="AuditData" :ruleList="ruleList" @showNotefile="showNotefile" @downNotefile="downNotefile" @urgent="urgents" @approuserMore="approuserMore" @subComment="subComment" />
              </div>
            </div>
          </div>
        </template>

        <!-- 区块链数据对比加载效果 -->
        <div class="drwaer" v-if="blockchainLoading">
          <div class="wrapper"></div>
        </div>
        <!-- 区块链数据对比 -->
        <blockchainDom
          v-if="blockchainDomShow"
          v-show="blockchainReadyShow"
          @readyShow="blockchainReadyFun"
          :approvalId="AuditData.approving.approvalId"
          :approvingId="AuditData.approvingId"
          :userapprovingId="AuditData.userapprovingId"
        />
      </component>

    </div>
    <el-dialog
      v-model="dialogVisible"
      :before-close="dialogClose"
      v-if="dialogVisible"
    >
      <template>
        <el-carousel
          :interval="5000"
          arrow="always"
          height="500px"
          :initial-index="initialIndex"
        >
          <el-carousel-item
            v-for="(item, index) in dialogImageUrl"
            :key="index"
          >
            <h3 style="text-align: center">
              <img
                style="max-width: 100%; max-height: 500px"
                :src="item.url"
                alt
              />
            </h3>
          </el-carousel-item>
        </el-carousel>
      </template>
    </el-dialog>
    <!-- 已读列表 -->
    <el-dialog
      v-model="dialogLookUpVisible"
      class="noPaddingDialog"
      width="858px"
      id="reade"
      append-to-body
      v-show="dialogLookUpVisible"
    >
      <template>
        <el-tabs v-model="reade" class="reade">
          <el-tab-pane
            label="已读"
            name="1"
            style="height: 330px"
            v-if="LookUpData"
          >
            <el-scrollbar
              style="height: 350px"
              v-loading="dialogLookUpVisibleLoading"
            >
              <ul class="readeClass">
                <li v-for="item in LookUpData.read" :key="item.id" class="user">
                  <span>{{ item.realname || item.name }}</span>
                  <template v-for="(orgItem, org_i) in item.organizationNamess">
                    <span
                      :key="orgItem.id"
                      v-if="org_i < 2 && orgItem !== ''"
                      class="ellipsis"
                      :title="orgItem"
                      >{{ orgItem }}</span
                    >
                  </template>
                  <!-- <template v-for="(orgItem,org_i) in item.orgname">
                    <span :key="orgItem.id" v-if="org_i < 2" class="ellipsis" :title="orgItem">{{orgItem}}</span>
                  </template>-->
                </li>
              </ul>
            </el-scrollbar>
          </el-tab-pane>
          <el-tab-pane
            label="未读"
            name="0"
            style="height: 330px"
            v-if="LookUpData"
          >
            <el-scrollbar
              style="height: 350px"
              v-loading="dialogLookUpVisibleLoading"
            >
              <ul class="readeClass">
                <li
                  v-for="item in LookUpData.unread"
                  :key="item.id"
                  class="user"
                >
                  <span>{{ item.realname || item.name }}</span>
                  <template v-for="(orgItem, org_i) in item.organizationNamess">
                    <span
                      :key="orgItem.id"
                      v-if="org_i < 2 && orgItem !== ''"
                      class="ellipsis"
                      :title="orgItem"
                      >{{ orgItem }}</span
                    >
                  </template>
                  <!-- <template v-for="(orgItem,org_i) in item.orgname">
                    <span :key="orgItem.id" v-if="org_i < 2" class="ellipsis" :title="orgItem">{{orgItem}}</span>
                  </template>-->
                </li>
              </ul>
            </el-scrollbar>
          </el-tab-pane>
        </el-tabs>
        <div style="text-align: right">
          <el-pagination
            v-if="lookUpDataTotal && lookUpDataTotal > 50"
            layout="prev, pager, next"
            @current-change="upLookFun"
            :page-size="50"
            :total="lookUpDataTotal"
          ></el-pagination>
        </div>
      </template>
    </el-dialog>
    <!--多人会签中-->
    <el-dialog
      title="多人会签中"
      v-model="dialogApprouserMore"
      class="dialognewclass"
      width="800px"
      append-to-body
      v-if="approuserMoreData"
    >
      <el-scrollbar
        style="height: 400px; background-color: #ffffff"
        class="el-menu-scrollbar__wrap"
      >
        <div class="to">
          <ul class="mode-cto-class">
            <li v-for="cto in filteredApprouserMoreData" :key="cto.id">
              <p class="name">
                <strong
                  style="
                    display: inline-block;
                    width: 100%;
                    margin-bottom: 10px;
                  "
                  >{{ cto.user && cto.user.realname }}</strong
                >
                <template v-if="cto.user && cto.user.orgname && cto.user.orgname != ''">
                  <span
                    v-for="(orgnameL, orgnameInde) in orgneFun(cto.user.orgname)"
                    v-show="orgnameInde < 3 && (!orgnameL.uservisible || orgnameL.uservisible !== 1)"
                    :key="orgnameL.id"
                    >{{ orgnameL.name || orgnameL }}</span
                  >
                </template>
              </p>
            </li>
          </ul>
        </div>
      </el-scrollbar>
    </el-dialog>
    <!-- 二维码 -->
    <vue-qr-code ref="vueqrcoderef" v-if="dialogvueqr" />
    <div v-if="!open">
      <!-- 重新编辑弹窗 -->
      <component
        v-bind:is="componentType"
        v-model="isInput"
        :destroy-on-close="true"
        :show-close="false"
        append-to-body
        :close-on-click-modal="false"
        :class="pdheight== 'auto' ? 'application-routing-dialog-all dialog-height-auto' : 'application-routing-dialog-all'"
        :top="routingFlowshow ? '0' : '8.9vh'"
        :width="widthComp"
        :size="diaSize"
        :with-header="false"
        @close="$emit('close')"
      >
        <div class="dialog-top">
          <div class="apply-name">
            {{ AuditData && AuditData.appname ? AuditData.appname : "" }}
          </div>
          <div class="apply-close" @click="isInput = false">
            <i class="icon iconfont icon-shanchu3" />
            关闭
          </div>
        </div>
        <oaExamineInput
          :approvalId="inputObj.approvalId"
          :approvingId="inputObj.approvingId"
          v-model:isAi="isInputAi"
          :modify="modify"
          @upIsAi="upIsAi"
          type="1"
          :person="1"
          @retRefresh="retRefresh"
          @inputClose="inputClose"
          v-if="isInput"
        />
      </component>
    </div>

    <multipleChoice
      ref="multipleChoiceChild"
      v-on:fromMultipleChoice="fromMultipleChoice"
    ></multipleChoice>

    <oaauditprinting
      ref="oaAuditPrintingChild"
      :printingdata="childAuditData"
      v-on:eventPrintingChild="eventPrintingChild"
    ></oaauditprinting>

    <oaExamineComment
      ref="oaExamineComment"
      v-if="isInit && AuditData"
      :templateDate="AuditData.approvingFormdata"
      :templateModify="ruleList"
      @retSubComment="subComment"
      @loadingFun="loadingFun"
      element-loading-text="数据加载中"
    ></oaExamineComment>

    <oaExamineUrgent ref="oaExamineUrgent"></oaExamineUrgent>

    <dialogRecord
      ref="dialogRecord"
      @previewPictureImg="previewPicture"
    ></dialogRecord>
    <!-- 打印预览 -->
    <print-box
      ref="printBox"
      :key=" 'print' + printBoxKey"
      v-model:isView="printBoxShow"
      v-model:isOpen="printBoxOpen"
      :title="printTitle"
      :formdata="printFormdata"
      :deptGroup="deptGroup"
      :detailConfig="printBoxConfig"
      :auditList="AuditList"
      :auditbuttonList="buttonList"
      @close="printBoxKey++"></print-box>
    <!-- 原页面打开的方式 -->
    <!-- 自定义 -->
    <div v-if="open" v-cloak class="cur-detail" element-loading-text="数据加载中">
      <template v-if="viewDetailFun === 'app-detail'">
        <template v-if="!isInput">
          <el-scrollbar :style="[getLeftWidth(), { paddingBottom: sDetel || sUpdate ? '60px' : '0' }]" class="app-detail-scrollbar">
            <div v-if="isNews">
              <div class="app-name-class2">
                {{ showNewsTitle }}
              </div>
              <detailCount
                v-if="AuditData"
                ref="detailCount"
                :isComment="isComment"
                :isNews="true"
                :isNewPage="true"
                :AuditData="AuditData"
                :skey="skey"
                :AuditList="AuditList"
                :otherConfig="otherConfig"
                :subTitle="baseSet.subTitle || []"
                :formdata="formdata"
                @comment="review"
                @open-to-list="lookUp(1)"
              />
            </div>
            <!-- 主题设计 -->
            <theme
              v-if="isOpenTheme"
              :themeConfig="themeConfig"
            />
            <!-- 自定义页面的导航 -->
            <customPageNav
              v-if="customCanvasLength > 1"
              :navType="pageSet.navType"
              :currentIndex="customCanvasIndex"
              :canvasLength="customCanvasLength"
              :canvasConfig="pageSet.configList"
            />
            <el-form
              v-show="!isCustom"
              :model="ruleForm"
              ref="ruleForm"
              label-width="160px"
              :label-position="'top'"
              class="demo-ruleForm form-class"
            >
            <!-- 默认 -->
              <widget-one-layer
                v-if="!websiteSwitch && AuditData"
                v-model:ruleListChild="ruleList"
                v-model:approvalId="AuditData.approving.approvalId"
                v-model:approvingId="AuditData.approvingId"
                :formdata="formdata"
                :othersObj="othersObj"
                :associationVisible="associationVisible"
                :layout="layout"
                :baseSet="baseSet"
                :opensafe="opensafe"
                :isNews="isNews"
                :customData="customData"
                :isFiexdCanvas="isFiexdCanvas"
                :fiexdCanvasInfo="fiexdCanvasInfo"
                ref="widgetOneLayerRef"
                @previewPictureImg="previewPicture"
                @record="upRecord"
                @widgetOneLayerEmit="widgetOneLayerEmitFun"
                @setAi="setAi"
              ></widget-one-layer>
              <web-site-widget-one-layer
                v-if="websiteSwitch"
                v-model:ruleListChild="ruleList"
                :approvalId="AuditData && AuditData.approving && AuditData.approving.approvalId"
                :approvingId="AuditData && AuditData.approvingId"
                :formdata="formdata"
                :othersObj="othersObj"
                :associationVisible="associationVisible"
                :layout="layout"
                :isNews="isNews"
                :isFiexdCanvas="isFiexdCanvas"
                :fiexdCanvasInfo="fiexdCanvasInfo"
                ref="webSiteWidgetOneLayerRef"
                @previewPictureImg="previewPicture"
                @record="upRecord"
                @widgetOneLayerEmit="widgetOneLayerEmitFun">
              </web-site-widget-one-layer>
              <!--以下为告知-->
              <div class="cto-list" v-if="!isNews && ctoShow && AuditList && Number(AuditList[0].cctotal) !== 0">
                <el-row
                  class="cto-row"
                  :gutter="40"
                  type="flex"
                  style="flex-wrap: wrap;"
                >
                  <el-col
                    :span="24"
                  >
                    <div class="inner" :class="layout ==11 || layout ==12 || layout === 14 ? 'inner' : 'inner inner-layout'">
                      <span class="title">通知对象</span>
                      <div class="list-detail">
                        <span
                          class="blueBtn"
                          @click="lookUp(1)"
                        >总共{{ AuditList[0].cctotal }}人，已读{{ AuditList[0].ccread }}人，未读{{ AuditList[0].cctotal - AuditList[0].ccread }}人</span>
                        <div
                          class="list-box"
                        >
                        <el-tag type="primary" v-for="item in checkedFlowArr" :key="item.organizationId" style="margin:3px">{{item.name}}</el-tag>
                        <el-tag type="primary" v-for="item in checkedRoleArr" :key="item.roleId" style="margin:3px">{{item.name}}</el-tag>
                        <el-tag type="primary" v-for="item in checkedGroupArr" :key="item.folderId" style="margin:3px">{{item.realname || item.name}}</el-tag>
                        <el-tag type="primary" v-for="item in checkedArrUser" :key="item.userId" style="margin:3px">{{item.realname || item.name}}</el-tag>
                        </div>
                      </div>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </el-form>
            <!-- 自定义详情页 -->
            <customWidgetOneLayer
              v-if="isCustom && !isHtml"
              :skey="skey"
              :tableData="formdata"
              :ruleListChild="ruleList"
              :workshopFormdata="workshopFormdata"
              :detailConfig="pageSet"
              :commentData="{AuditList,checkedFlowArr,checkedRoleArr,checkedArrUser,checkedGroupArr}"
              :customCanvasIndex="customCanvasIndex"
              @close="closeDialog"
              @lookUp="(e)=>{lookUp(e)}"
            ></customWidgetOneLayer>
          </el-scrollbar>
          <div class="open-details-foot" v-if="AuditData && (sDetel || sUpdate)">
            <el-button style="margin-right: 10px;" class="el-danger-btn" type="primary" @click="editDataFn(AuditData)" v-if="sUpdate && !(AuditData.type == 1 && AuditData.status == 0)">编辑</el-button>
            <template v-if="AuditData && AuditData.type == 0">
              <div class="footerBtn"  @click="flowBtn(9)" v-if="Number(AuditData.status) !== 3 && Number(AuditData.status) !== 2 && pass === 1">
                <i class="iconfont icon-zhuanfa"></i> 传阅
              </div>
              <template v-if="AuditData.status != 1">
                <div class="footerBtn" v-if="AuditData.status == 3 || AuditData.status == 2">
                  <el-button class="staingBtn" @click="resubmit(AuditData)">重新编辑</el-button>
                </div>
                <div class="footerBtn" v-else>
                  <el-button type="primary"  @click="cancel(3, '撤销')" :disabled="AuditData.status == 0 ? false : true">撤 销</el-button>
                </div>
              </template>
            </template>
            <el-button plain class="el-danger-btn" style="margin-right: 10px;margin-top: 0;" type="danger" @click="delDataFun" v-if="sDetel && !(AuditData.type == 1 && AuditData.status == 0)">删除</el-button>
          </div>
        </template>
        <template v-else>
          <oaExamineInput
            :approvalId="inputObj.approvalId"
            :approvingId="inputObj.modifyId"
            v-model:isAi="isInputAi"
            :modify="modify"
            @upIsAi="upIsAi"
            style="height: 100%;"
            type="1"
            :person="modify && modify.person"
            @retRefresh="retRefresh"
            @inputClose="inputClose"
          />
        </template>
      </template>
      <template v-else-if="viewDetailFun === 'app-comment'">
        <div class="oaExamineRight" style="background-color: #fff; height: 100%;" v-if="AuditList && AuditList.length > 0" :class="baseSet && baseSet.flowshow && baseSet.flowshow.width ? 'ctoAllArea-flow' : ''">
          <div class="ctoArray-class">
            <template v-if="!baseSet || !baseSet.flowshow || baseSet.flowshow.type === 'merge'">
              <el-scrollbar v-if="isOpenFlow" class="el-menu-scrollbar__wrap" style="height: 100%">
                <div>
                  <div class="process">
                    <el-timeline style="padding: 15px">
                      <template v-for="(value, indeex) in AuditList" :key="value.id">
                        <el-timeline-item :class="['timeline-blue', ('timeline-' + statusObj[indeex === 0 && value.status === 0 ? 1 : value.status])]" :icon="value.status !== 0 || indeex === 0 && value.status === 0 ? 'el-icon-check' : ''">
                          <el-card
                            :body-style="{
                              padding: '13px 14px',
                              position: 'relative',
                            }"
                          >
                            <!-- <i class="iconfont icon-renyuanfuzhi6 icon-timeLine-user" /> -->
                            <el-row>
                              <!-- 用户名 -->
                              <el-col :span="24" style="display:flex;align-items:center;">
                                <span class="name">{{ value.user ? value.user.realname : "" }}</span>
                                <div class="orgname" v-if="value.user && value.user.orgname">
                                  <template v-for="(orgne, index) in orgneFun(value.user.orgname)">
                                    <span v-if="!orgne.uservisible && orgne.uservisible !== 0 || orgne.uservisible === 1" v-show="index < 2" :key="orgne.id">{{ orgne.name || orgne }}</span>
                                  </template>
                                </div>
                              </el-col>
                              <el-col
                                :span="24"
                                class="urgent-class"
                                v-if="
                                reminder && (
                                  indeex !== 0 &&
                                  Number(AuditList[0].status) === 0 &&
                                  AuditData.userapprovingId > 0 &&
                                  AuditData &&
                                  !AuditData.userccappId &&
                                  AuditData.type !== 9 &&
                                  value.status == '0' &&
                                  value.type == 1 &&
                                  value.way != 3)
                                "
                              >
                                <span class="blueBtn"
                                  title="催办一下，TA会收到消息推送"
                                  @click=" urgent( value.approuser || [value.user], value.userapprovingId ) " >催办</span
                                >
                              </el-col>
                              <div style="width:100%;padding-top: 10px">
                                <el-col :span="16" class="AuditList-head">
                                  <template v-if="value.way && value.way == 4">
                                    <span class="sponsor">
                                      {{ approvalProcess4(value, buttonList) }}
                                    </span>
                                  </template>
                                  <template v-else-if="value.way && value.way == 3">
                                    <span class="yellow" v-if="value.way == 3">
                                      {{ launchdataPl }}
                                    </span>
                                  </template>
                                  <template v-else>
                                    <template v-if="value.type == 0">
                                      <span
                                        class="recall"
                                        v-if="value.status == 3"
                                        >{{ launchdataChH }}</span
                                      >
                                      <span
                                        class="sponsor"
                                        :style="
                                          launchdata === '发起'
                                            ? 'color:#4e86ff;'
                                            : ''
                                        "
                                        v-else
                                        >{{ launchdata }}</span
                                      >
                                      <!--type=0并且status:4重新提交，status为3 是撤回-->
                                    </template>
                                    <template v-else>
                                      <span
                                        class="success"
                                        v-if="value.status == '1' && value.way != 3">
                                        {{ approvalProcess2(value, buttonList) }}
                                      </span>
                                      <span
                                        class="approval-stat"
                                        v-else-if="(value.status == '0' && value.way != 3) || value.status == '4'">
                                        {{ approvalProcess1(value, buttonList) }}
                                      </span>
                                      <span
                                        class="pass"
                                        v-else-if="value.status == '2' && value.way != 3">
                                        {{ approvalProcess3(value, buttonList) }}
                                      </span>
                                      <span v-else class="def-d">待办</span>
                                    </template>
                                  </template>
                                  <span
                                    @click="approuserMore(value.approuser)"
                                    :class="['blueBtn', getIconBackFlow(value)]"
                                    v-if="value.approuser && value.approuser.length > 1"
                                    ><i class="iconfont icon-a-zu181" /></span>
                                  <span v-if="isTime === 0 && (value.status != 0 && value.status !== -1 || indeex === 0)" class="time">
                                    <i class="iconfont icon-a-zu148" />
                                    {{ formatTimestamp(value.ctime) }}
                                  </span>
                                </el-col>
                              </div>
                              <el-col v-if="value.approuser && value.approuser.length > 1" :span="24" style="padding-top: 14px;">
                                <span class="span-text">多人处理</span>
                              </el-col>
                              <el-col
                                :span="24"
                                v-if="value.note || value.comment"
                              >
                                <div class="comment-class">
                                  {{ value.note }}{{ value.comment }}
                                </div>
                              </el-col>
                              <el-col
                                :span="24"
                                v-if="value.sign"
                              >
                                <div class="sign-class">
                                  签名：
                                  <img :src="$imgurl+value.sign+'?accesstoken='+token" alt="">
                                </div>
                              </el-col>
                              <!-- 附件 -->
                              <el-col
                                :span="24"
                                v-if="
                                  (value.notefile &&
                                    Array.isArray(value.notefile)) ||
                                  (value.notefile && value.notefile.length > 2)
                                "
                              >
                                <div
                                  class="notefile-class"
                                  v-for="file in JSON.parse(value.notefile)"
                                  :key="file.id"
                                >
                                  <p @click="showNotefile(file)">
                                    <i
                                      class="iconfont icon-fujian"
                                      style="font-size: 14px; font-weight: normal"
                                    />
                                    {{ BatchFileName(file) }}
                                  </p>
                                  <p class="noteicon">
                                    <a
                                        @click="downNotefile(file)"
                                      href="#"
                                      class="icon iconfont icon-xiazai2x"
                                    ></a>
                                  </p>
                                </div>
                              </el-col>
                            </el-row>
                          </el-card>
                        </el-timeline-item>
                      </template>
                      <el-timeline-item
                        color="#fff"
                        size="large"
                        class="timeline-red timeline-end"
                        icon="icon-end"
                        v-if="AuditData && AuditData.approving.status != 0"
                      >
                        <p style="color: #738390; padding-top: 8px">流程结束</p>
                      </el-timeline-item>
                    </el-timeline>
                  </div>
                </div>
                <!--以下为告知-->
                <el-row v-if="isCustom && AuditList && Number(AuditList[0].cctotal) !== 0">
                  <el-col :span="24">
                    <p class="title">通知对象</p>
                  </el-col>
                  <el-col :span="12" style="padding: 15px; color: #999">
                    总共{{ AuditList[0].cctotal }}人，{{
                      AuditList[0].ccread
                    }}人已读
                  </el-col>
                  <el-col :span="12" style="text-align: right; padding: 15px">
                    <span class="blueBtn" @click="lookUp(1)">查看全部</span>
                  </el-col>
                </el-row>
              </el-scrollbar>
              <div v-else style="display: flex;width: 100%;height: 100%;align-items: center;justify-content: center;">未开启流程</div>
            </template>
            <flowShow v-else :isOpenFlow="isOpenFlow" :flowshow="baseSet.flowshow" :AuditList="AuditList" :reminder="reminder" :isTime="isTime" :buttonList="buttonList" :opencomment="opencomment" :AuditData="AuditData" :ruleList="ruleList" @showNotefile="showNotefile" @downNotefile="downNotefile" @urgent="urgents" @approuserMore="approuserMore" @subComment="subComment" />
          </div>
        </div>
      </template>
      <div v-if="isAi === 1 && aiStatus" class="oaExamineRight ctoAllArea-ai" :style="getAiAreaStyle()">
        <div class="resize-handle" @mousedown="startResize"></div>
        <chat-box :robotConfig="robotConfig.view" :modelConfig="robotConfig.view && robotConfig.view.robot ? robotConfig.view.robot : []" :approvalId="AuditData.approving.approvalId" :approvingId="AuditData.approvingId || AuditData.approving.approvingId" :appfile="appfile" :formdata="formdata" :appAgentConfig="appAgentConfig" @textInsert="textInsert" @close="closeDialog" />
      </div>
    </div>
    <!-- 日志查看 -->
    <log
      v-if="isViewLog"
      v-model:isLogView="isViewLog"
      :approvalId="AuditData.approving.approvalId"
      :approvingId="AuditData.approving.approvingId"
    />

    <widgetLinkOpen ref="widgetLinkOpen" :linkConfig="linkconfig" :diaSize="diaSize" />
  </div>
</template>

<script>
import { defineAsyncComponent } from 'vue'
import { axiosBase } from "@/api/api";
import { oaAuditPrintingFunc } from "../../api/index";
import DealPrintData from '@/components/common/detailEdit/utils/dealPrintData.utils.js'
import { sheetDefaultConfig } from '@/components/common/detailEdit/detailConfig.js'

import {
  openapiGetuserccapprovallist,
  openapiApprovingdistribute,
  openapiGetapprovinguser,
  openapiGetapproval,
  openapiUpdateuserccapproving,
  openapiAddreordcount,
  outaddreordcount
} from "@/port/clientSide/oaExamineAudit";
import {
  getapprovaldetail,
  getdetailapprovinglist,
  getwebsiteapproval,
  getwebsiteapprovalreportdatalist
} from "@/port/pages/webSite"
import { openapiGetuserapprovinglist } from "@/port/clientSide/oaExamine";
import { openapiUpdateuserapproving } from "@/port/clientSide/oaExamineComment";
import {
  headconver,
  formatDate,
  BatchFileName
} from "@/api/global.js";
import {
  momVal,
  assignFormdata,
  setOthersFormdata,
  othersRed,
  copyObj,
  getConfigFromUrl,
  isJSON,
  getStatusBtnText
} from "@/api/utils";
import widgetOneLayer from "@/components/clientSide/formFillinPageChild/widgetOneLayer";
// 内网自定义的详情页
import customWidgetOneLayer from "@/components/clientSide/formFillinPageChild/customWidgetOneLayer";
import oaExamineInput from "./oaExamineInput.vue";
import { getLogin, loginAi, addTalk, getRobotToken } from '@/api/openAi'
import { generateMathRandom } from '@/api/drage'
import { apiDeleteapproving } from '@/port/personal/personal'
import { getaimanageconfig } from '@/port/admins/ai'
import parmsMixins from '@/components/schoolInstrument/mixins/parmsMixins'
import { cloneDeep } from 'lodash';
import { dealInputConfig, getOtherAppConfig  } from "@/components/common/detailEdit/fixedCanvas/js/fixedCanvas.util.js";
export default {
  name: "oaExamineAudit",
  components: {
    oaExamineAuditChildren: defineAsyncComponent(() => import('./formFillinPageChild/oaExamineAuditChildren.vue')),
    multipleChoice: defineAsyncComponent(() => import('@/components/common/multipleChoice.vue')),
    oaauditprinting: defineAsyncComponent(() => import('./oaAuditPrinting.vue')),
    oaExamineComment: defineAsyncComponent(() => import('./oaExamineComment.vue')),
    oaExamineCommentNew: defineAsyncComponent(() => import('./oaExamineCommentNew.vue')),
    oaExamineUrgent: defineAsyncComponent(() => import('./oaExamineUrgent.vue')),
    widgetOneLayer,
    customWidgetOneLayer,
    webSiteWidgetOneLayer: defineAsyncComponent(() => import('@/components/clientSide/formFillinPageChild/webSiteWidgetOneLayer')), // 官网的详情页
    dialogRecord: defineAsyncComponent(() => import('./common/dialogRecord.vue')),
    oaExamineInput,
    vueQrCode: defineAsyncComponent(() => import('@/components/clientSide/common/vueQrCode.vue')),
    blockchainDom: defineAsyncComponent(() => import('@/components/clientSide/blockchain/blockchain')),
    theme: defineAsyncComponent(() => import('@/components/clientSide/formFillinPageChild/theme.vue')),
    PrintBox: defineAsyncComponent(() => import('@/components/common/detailEdit/excel/printBox.vue')),
    flowShow: defineAsyncComponent(() => import('./common/flowShow.vue')),
    detailCount: defineAsyncComponent(() => import('@/components/common/detailCount.vue')),
    log: defineAsyncComponent(() => import("./workbench/log/index")),
    widgetLinkOpen: defineAsyncComponent(() => import('./common/widgetLinkOpen.vue')),
    chatBox: defineAsyncComponent(() => import('@/components/common/chat/index')),
    drawBox: defineAsyncComponent(() => import('@/components/common/chat/draw')),
    customPageNav: defineAsyncComponent(()=>import('@/components/clientSide/formFillinPageChild/customPageNav.vue')),
  },
  mixins: [parmsMixins],
  props:{
    // 是否是新页面打开
    isNewPage: {
      type: Boolean,
      default: false
    },
    // 是否打开官网
    websiteSwitch: {
      type: Boolean,
      default: false
    },
    appInfo:{},
    open:{
      type:Boolean,
      default:false
    },
    // 门户那边传过来
    dialogInfo:{
      type: Object,
      default: () => {
        return {
          dialogName: '',
          isVisible: false,
          dialogWidth: '',
          dialogHeight: '',
          dialogUrl: ''
        }
      }
    },
    iId: {
      type:Number
    },
    openType: {
      type: String,
      default:'dialog'
    },
    diaSize: {
      type: String,
      default: '80%'
    },
    viewDetailFun: {
      type: String,
      default: 'app-detail'
    },
    tableStyleField:{
      type: Object,
      default: ()=>({})
    }
  },
  data () {
    return {
      appCustomData: [],
      statusObj: {
        '-1': '',
        0: 'primary',
        1: 'success',
        3: 'success',
        4: 'success',
        2: 'success'
      },
      opensafe: 0,  // 安全区域
			robot: 1,//当前选用的小易
			robots:[],// AI小易版本列表：0 chatgpt 1 文心一言 2 文心画图
      aiConfigList: [
        {
          name: 'ChatGPT',
          number: 0,
          label: 'AI易问'
        },
        {
          name: '文心一言',
          number: 1,
          label: 'AI易言'
        },
        {
          name: '文心一格',
          number: 2,
          label: 'AI易画'
        },
        {
          name: '通义千问',
          number: 3,
          label: 'AI易写'
        },
        {
          name: '电信 DeepSeek 671B',
          number: 5,
          label: 'dx-deepseek671b'
        },
        {
          name: '官方 DeepSeek R1',
          number: 6,
          label: 'deepseek-reasoner'
        },
        {
          name: '官方 DeepSeek V3',
          number: 7,
          label: 'deepseek-chat'
        }
      ],
      isAi: 0,
			aiStatus:false,
      flowshow: 2,
      onlyUser: 0, //流程仅发起人可见
      routingFlowshow: false, // true 放大 false 不放大
      oqrcore: 0, //二维码
      qrcodetypes: null,  // 新版二维码列表
      lookqrcode: 0, // 查看数据的二维码
      lookqrcodetypes: [], // 查看数据的二维码列表
      // 打开input的
      inputObj: {},
      isInput: false,
      isInit: false, //这里要拿到上一页的数据再来进行变动
      activeList: "one",
      fullScreenLoading: false,
      openLoading: false,
      dialogAuditVisible: false,
      dialogVisible: false,
      dialogLookUpVisible: false,
      // dialogFastReplyVisible: false,
      initialIndex: 0,
      childAuditData: null,
      dialogImageUrl: "",
      AuditData: null,
      AuditList: null,
      reade: 0,
      LookUpData: null,
      lookUpDataPage: 1,
      lookUpDataTotal: 0,
      //评论
      state3: "",
      fastReplyData: null,
      mode: 1,
      //流转转派更多
      dialogApprouserMore: false,
      approuserMoreData: null,
      launchdata: "发起",
      launchdataPl: "评论",
      launchdataChH: "撤回",
      isborcolor: false, //评论框边框颜色
      childType: 1, //区分是外层还是内层
      approvalIs: false,
      auditArr: {
        item: null,
        key: null
      },
      isLook: 0, // 0 头部已读 1 底部已读
      buttonList: [], //审批按钮列表
      ruleList: [],
      ruleForm: {},
      tipsIs: false, //是否需要验证提醒数据重复，可以提交
      addEventFooter: null,
      dialogLookUpVisibleLoading: false,
      isTime: 0, // 是否显示时间 0 显示 1 不显示
      formdata: null, // 值存储
      printFormdata: null, // 打印值存储
      pass: 0, //- 表单的传阅空间需要后台新增开启的按钮确定才能开启使用
      othersObj: {},
      layout: 2,
      comment: "", // 告知评论
      associationVisible: "",
      dialogvueqr: false,
      userMsg:{},
      //- 区块链数据状态1:没有问题，2有问题
      blockchainStuts: 1,
      //- 判断区块链数据对比按钮是否显示
      blockchainShow: false,
      //- 区块链数据对比是否可以显示了
      blockchainReadyShow: false,
      //- 区块链数据对比弹框显示
      blockchainDomShow: false,
      //- 区块链数据对比加载显示
      blockchainLoading: false,
      // 官网的秘钥
      skey: null,
      skeyNoLocal: null,
      // 自定义详情页
      isCustom: false,// 是否是自定义详情页
      pageSet: {},
      othersFormdata: null, // 自定义详情页他表值存储
      workshopFormdata: {}, // 自定义详情页数据工坊值存储
      tempformdata: {},
      token: '',
      themeConfig: {}, // 主题设计的样式
      isOpenTheme: false, // 是否开启主题设计
      reminder: true, // 是否开启催办
      transfer: true, // 是否开启转办
      transferConfig: [],  // 转办可选组织 为空则可选全部
      printConfig: [], // 自定义打印的所有配置
      printBoxConfig: sheetDefaultConfig, // 传入打印盒子的配置给个默认的配置
      printBoxKey: 0, // 传入打印盒子的配置给个默认的配置
      printTitle: '',// 传入打印盒子的标题
      isCustomPrint: false, // 是否开启自定义打印
      printBoxShow: false, // 打印预览数据的显示隐藏
      printBoxOpen: false, // 打印预览弹窗的显示隐藏
      // ai 使用
      isAiLoading: false,
      talkId: '',
      userImg: '',
      pdwidth: 75,
      pdheight: 'regular',
      aiTextarea: 1,
      chaeckAi: null,
			boxVisiable:false,
      isSpace: false, // 是否从空间进入
      isUpace: false, // 是否从空间进入
      // 日志查看
      isViewLog: false,
      sDetel: null,
      sUpdate: null,
      sMyoplog: null,
      tipsize: 14,
      pageSetPopupStyle: 'default', // 'default' or 'simple' 详情页弹窗配置
      opencomment: false,
      deptGroup: {},
      returnto: {}, //默认环节设置-是否开启转办
      commentNewStatus: null, //是否显示单页面审批ui
      commentHeight: false, //单页面审批是否改变了高度
      //组织架构的参数
      checkedFlowArr: [],
      //用户参数
      checkedArrUser:[],
      //角色的参数
      checkedRoleArr: [],
      // 分组的参数
      checkedGroupArr: [],
      // 链接配置
      linkconfig: {
        open: false,
        terrace: false,
        link: false,
        field: '',
        openConfig: 'original'
      },
      // 默认当前流程结束（给直接打开链接用的）
      endStart: false,
      isShowDefaultPrint: true,
      baseSet:{
        grouping: 0, // 0：当前用户 1：当前应用
        flowshow: {
          type: 'merge',
          width: '345px'
        }
      }, // 流程设置新增的JSON
      isNews: null, // 是否开启新闻模式
      ctoShow: true, // 是否显示通知对象
      customNewsTitle: '', // 取消了固定模式的新闻标题
      newsTitle: '', // 开启了固定模式的新闻标题
      otherConfig: {}, // 其他配置
      defaultPrintShowKey: {}, // 默认打印报表的字段显示配置
      refreshTemp: {}, // 刷新模板
      robotConfig: {}, //AI小易配置信息
      appfile: {}, //文件解析配置信息
      examineHeight: 0, // 新增存储高度的变量
      customData: [], // 应用的变量
      isResizing: false,
      startX: 0,
      startWidth: 0,
      minWidth: 390, // 最小宽度
      maxWidth: 2000, // 最大宽度
      customInputAppInfo: {}, // 自定义配置页的表单信息
      isFiexdCanvas: false,
      customCanvasIndex: 0, // 自定义详情页当前显示的画布下标
      isUsePx: false,
      appProperty: [],
      isOpenFlow: false, // 是否打开了流程
      pageType: '', // 当前页面使用自定义还是默认页面 空值就使用页面设计那边设置的
      isInputAi: 0,
      modify: null,
      appAgentConfig: {}, //AI查看辅助-样式
      spaceId: 0,
      upaceId: 0,
      user: {},
      isHtml: false,
      htmlInfo: {
        url: ''
      }
    }
  },
  watch: {
    isNewPage: {
      handler (val) {
        if (val) {
          // 如果是新页面
          this.routingFlowshow = true
        }
       },
      immediate: true,
    },
    openLoading: {
      handler(val) {
        setTimeout(() => {
          // 5秒后自动关闭
          if (val) {
            this.openLoading = false
          }
        }, 5000);
      },
      immediate:true
    },
    reade () {
      if (this.dialogLookUpVisible) {
        this.getLookUp();
      }
    },
    dialogLookUpVisible (val) {
      if (!val) {
        this.dialogLookUpVisibleLoading = false;
      }
    },
    dialogVisible (val) {
      if (!val) {
        this.dialogImageUrl = "";
        this.initialIndex = 0;
      }
    },
    isInput (val) {
      if (!val) {
        this.inputObj = {};
        this.isInputAi = 0
        this.modify = null
      }
    },
    isAi: {
      immediate: true,
      handler (val) {
        if (val === 1 && !this.talkId) {
          // this.getAiName()
					for(let i = 0;i<this.robots.length;i++){
						switch(this.robots[i]){
							case 0:
								// ai 打开之后必然有返回一个 talkId
                // 易问模型不续费，部分用户已经配置了易问先注释，改成调用deepseek模型
								// this.getAi()
								break
							case 1:
								this.getWYYX()
								break
							case 2:
								this.getWYYX()
								break
						}
					}
        }
      }
    },
    pdwidth: {
      immediate: true,
      handler(val) {
        this.$emit('upIsPcwidth', val, this.isUsePx)
      }
    }
  },
  computed: {
    approvalIdValue(){
      return this.AuditData && this.AuditData.approving && this.AuditData.approving.approvalId
    },
    approvingIdValue(){
      return this.AuditData && this.AuditData.approvingId
    },
    showNewsTitle () {
      let title = this.newsTitle
      if (this.baseSet && this.baseSet.isCustomTitle) {
        title = this.customNewsTitle
      }
      return title || ''
    },
    fiexdCanvasInfo () {
      return this.customInputConfig && this.customInputConfig.configList && this.customInputConfig.configList[this.customCanvasIndex]
     },
    customCanvasLength () {
      let len = 0
      if (this.pageSet && this.pageSet.configList) {
        len = this.pageSet.configList.length
      }
      return len
    },
    isComment() {
      return this.opencomment && ((!this.flowshow || this.flowshow !== 2 ) && (!this.baseSet || this.baseSet && !this.baseSet.flowshow || this.baseSet && this.baseSet.flowshow && !this.baseSet.flowshow.type || this.baseSet && this.baseSet.flowshow && this.baseSet.flowshow.type !== 'dialogue'))
    },
    widthComp() {
      let width = this.dialogInfo.dialogWidth ? this.dialogInfo.dialogWidth : this.routingFlowshow ? '100%' : (this.pdwidth + '%')
      const obj = {
        11: true,
        13:true,
        14:true,
        15:true,
        16:true,
      }
      // 有设计详情页就是用详情页的画布作为
      if (this.isCustom && this.pageSet.configList) {
        const canvas = this.pageSet.configList[0]
        width = canvas.canvasWidth + 'px' || width
      } else {
        if (obj[this.iId]) {
          width = this.pdwidth + '%'
        }
      }
      return width
    },
    componentType() {
      const obj = {
        dialog: 'el-dialog',
        rightdia: 'el-drawer'
      }
      if (!this.openType) return 'el-dialog'
      return obj[this.openType]
    },
    headconver: function () {
      return this.AuditData.avatar ? headconver(this.AuditData.avatar) : '';
    },
    getCurFlow() {
      const approver = this.AuditData.approving.approver || []
      const step = this.AuditData.approving.step
      const cur = approver[step] || {}
      return cur
    },
    getStatus0() {
      // 获取处理状态为0
      const cur = this.getCurFlow
      if (cur.customStatus) {
        return cur.customStatus
      } else {
        return '处理中'
      }
    },
    getStatus1() {
      // 获取处理状态为0
      const cur = this.getCurFlow
      if (cur.customText) {
        return cur.customText.agree.showText
      } else {
        return '同意'
      }
    },
    getStatus2() {
      // 获取处理状态为0
      const cur = this.getCurFlow
      if (cur.customText) {
        return cur.customText.refused.showText
      } else {
        return '未通过'
      }
    },
    buttonListComputed(){
      const list = this.buttonList
      const flag = getStatusBtnText(this.AuditData)
      if (flag) {
        return flag.filter(c => c)
      } else {
        if (this.AuditData.approsel === -1) {
          return list[list.length - 1]
        } else {
          return list[this.AuditData.approsel]
        }
      }
    },
    auditDataName(){
      if (Array.isArray(this.AuditList) && this.AuditList.length > 0) {
        const current = this.AuditList.find(item=>item.type === 0)
        return current.name || current.user.realname
      } else {
        return this.AuditData.name
      }
    },
    filteredApprouserMoreData() {
      return this.approuserMoreData.filter(cto => cto.user);
    }
  },
  created () {
    const spaceId = this.$route.query.spaceid
    const spaceStatus = this.$route.query.space
    const upaceId = this.$route.query.upaceid
    const upaceStatus = this.$route.query.upace
    if (typeof(spaceId) !== 'undefined' || spaceStatus){
      this.isSpace = true
      this.spaceId = typeof(this.$route.query.spaceid) !== 'undefined' ? this.$route.query.spaceid : localStorage.getItem('spaceid')
    }
    else if (typeof(upaceId) !== 'undefined' || upaceStatus){
      this.isUpace = true
      this.upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
    }
    this.token = JSON.parse(localStorage.getItem('user')||'{}').accesstoken    
    try{
      const userImg = JSON.parse(window.localStorage.getItem('userMsg'))
      let url = ''
      if (userImg.avatar) {
        if (userImg.avatar.includes('img-')) {
          url = this.$imgurl + userImg.avatar
        } else {
          const list = userImg.avatar.split('/')
          const num = list[list.length - 1]
          let format = `${num}.jpg`
          if (Number(num)>=36) {
            format = `${num}.svg`
          }
          url = `https://bigdata.topeti.com/PCRepository/middleground/avatar/${format}`
        }
      } else {
        if (userImg.sex && userImg.sex === '女') {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/16.jpg'
        } else {
          url = 'https://bigdata.topeti.com/PCRepository/middleground/avatar/23.jpg'
        }
      }
      // this.$set(this, 'userImg',  url)
      this.userImg = url
    } catch(e) {
      console.log("eee==",e)
    }
  },

  methods: {
    editDataFn(item, isDialog = false) {
      this.modify = {
        approvalId: item.approving.approvalId,
        person: 1,
        modifyId: item.approving.approvingId
      }
      this.inputObj = {
          approvalId: item.approving.approvalId,
          type: 1,
          approvingId: item.approving.approvingId,
          modifyId: item.approving.approvingId
      }
      this.isInput = true
      if (isDialog) {
        let self = this;
        this.$nextTick(function () {
          self.dialogAuditVisible = false;
        })
      }
    },
    upIsAi(val) {
      // this.$set(this, 'isInputAi', val)
      this.isInputAi = val
    },
    customCanvasChange (type, jumpIndex) {
      if (!jumpIndex && jumpIndex !== 0) {
        if (type === 'prve' && this.customCanvasIndex <= 0) return false
        if (type === 'next' && this.customCanvasLength <= this.customCanvasIndex + 1) return false
        if (type === 'prve') {
          this.customCanvasIndex -= 1
        } else {
          this.customCanvasIndex += 1
        }
      } else {
        // 跳转的画布和目前一样就不要跳转了
        if (!this.pageSet.configList[jumpIndex] || this.currentIndex === jumpIndex) return false
        this.customCanvasIndex = jumpIndex
      }
      // 自由画布都不要走下面这里
      if (this.isFiexdCanvas) {
        // 设置弹窗尺寸
        this.setDiaSize()
        let property = cloneDeep(this.appProperty)
        const canvasConfig = this.pageSet.configList[this.customCanvasIndex]
        if (canvasConfig && canvasConfig.fixedCanvasAppid) {
          // 改变画布的模板和数据
          property = cloneDeep(this.customInputAppInfo[canvasConfig.fixedCanvasAppid].property)
          this.formdata = this.customInputAppInfo[canvasConfig.fixedCanvasAppid].formdata
          this.ruleList = dealInputConfig(canvasConfig, property)
        }
      }
    },
    getFlowShowText () {
      let str = '流程'
      if (this.baseSet && this.baseSet.flowshow) {
        const flowshow = this.baseSet.flowshow
        if (flowshow && flowshow.type) {
          if (flowshow.viewText) {
            str = flowshow.viewText
          } else {
            str = flowshow.type === 'dialogue' ? '交流' : '流程'
          }
        }
      }
      return str
    },
    getIconBackFlow (value) {
      if (value.way && value.way == 4) {
        return 'sponsor'
      } else if (value.way && value.way == 3) {
        return 'yellow'
      } else {
        if (value.type == 0) {
          if (value.status == 3) {
            return 'recall'
          } else {
            return 'sponsor'
          }
        } else {
          if (value.status == '1' && value.way != 3) {
            return 'success'
          } else if ((value.status == '0' && value.way != 3) || value.status == '4') {
            return 'approval-stat'
          } else if (value.status == '2' && value.way != 3) {
            return 'pass'
          } else {
            return 'def-d'
          }
        }
      }
    },
    getFlowWidth () {
      if (this.baseSet && this.baseSet.flowshow) {
        const ob = { width: this.baseSet.flowshow.width }
        if (this.baseSet.flowshow.type === 'dialogue') ob.backgroundColor = '#F1F2F3'
        return ob
      }
    },
    openLink (config) {
      let str = ''
      if (config.field) {
        const s = config.field.split('.')
        str = this.formdata[s[0]]
      }
      this.$refs.widgetLinkOpen.open(str)
      this.closeDialog()
    },
    // 删除本条数据
    delDataFun () {
      this.$confirm('确定要删除？', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          const res = await apiDeleteapproving({
            approvalId: this.AuditData.approving.approvalId,
            approvingId: this.AuditData.approving.approvingId
          })
          if (res.code === 0) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.$emit('sourceAudit', {isUp:true, key: 1})
            this.closeDialog()
          }
        })
    },
    // 查看日志
    getLog () {
      // this.$set(this, 'isViewLog', true)
      this.isViewLog = true
    },
    // 背景
    getBack (config) {
      const obs = {
        // 新闻模式下白背景
        backgroundColor: config.backConfig && config.backConfig === 'color' && config.backColor !== '#F9F9F9' ? config.backColor : (this.isNews ? '#FFFFFF' : '#F9F9F9')
      }
      obs.height = this.pageSetPopupStyle !== 'default' ? 'calc(100% + 1px)' : this.commentNewStatus === 1 ? this.commentHeight ? 'calc(100% - 334px)' : 'calc(100% - 170px)'
      : ((this.pageSet && this.pageSet.configList && this.pageSet.configList.length > 1) || this.sDetel || this.sUpdate ? 'calc(100% - 60px)' : 'calc(100% - 40px)')
      if (config.backConfig && config.backConfig === 'back') {
        delete obs.backgroundColor
        obs.backgroundImage = 'url("' + this.$imgurl + '/confiles/' + config.bodyBackground + '")'
        obs.backgroundSize = '100% 100%'
      }
      return obs
    },

    // 插入答案
    textInsert (val) {
      if (!this.chaeckAi) return
      if (this.chaeckAi.type !== 'details') {
        const type = this.chaeckAi.title + '_' + this.chaeckAi.type
        // this.$set(this.formdata, type, ((this.formdata[type] || '') + val.content))
        this.formdata[type] = ((this.formdata[type] || '') + val.content)
      } else {
        const values = this.formdata[this.chaeckAi.fType][this.chaeckAi.index][this.chaeckAi.title] || ''
        // this.$set(this.formdata[this.chaeckAi.fType][this.chaeckAi.index], this.chaeckAi.title, values + val.content)
        this.formdata[this.chaeckAi.fType][this.chaeckAi.index][this.chaeckAi.title] = values + val.content
      }
      val.event.preventDefault()
    },
    setAi (val) {
      console.log('答案状态变更', val)
      // this.$set(this, 'chaeckAi', val)
      this.chaeckAi = val
    },
    getLeftWidth () {
      if(Object.keys(this.appAgentConfig).length !== 0){
        return 'width: 0'
      }
      if (this.baseSet && this.baseSet.flowshow && this.baseSet.flowshow.width) {
        const w = this.flowshow === 1 ? this.baseSet.flowshow.width.substring(0, this.baseSet.flowshow.width.length - 2) : 0
        // const aiWidth = this.isAi && (this.isAi === 1 || this.isAi === 3) && this.aiStatus ? (this.pdwidth >= 80 ? 460 : 320) + 12 : 0
        // 没开启流程
        if(w === 0){
          if(this.isAi !== 1 && this.isAi !== 3){
            return 'width: 100%'
          }
          else{
            return this.robotConfig.view && this.robotConfig.view.aiBoxWidth ? `width:calc(100% - ${Number(this.robotConfig.view.aiBoxWidth)}%)` : 'width:100%'
          }
        }
        else{
          // 获取主区域总宽度          
          if(this.isAi !== 1 && this.isAi !== 3){
            const pdwidth = this.pdwidth || 80; // 默认80
            const widthRatio = pdwidth / 100;
            const browserWidth = window.innerWidth || document.documentElement.clientWidth;
            const eightyPercentWidth = browserWidth * widthRatio;
            let mainareaWidth = eightyPercentWidth - w;
            return `width:${mainareaWidth}px`
          }
          else{
            const mainArea = document.querySelector('.oaExamineAllArea');
            let mainareaWidth = mainArea ? mainArea.offsetWidth - w : 0;
            // 判断是否需要50%宽度
            return `width:${mainareaWidth / 2 || 0}px`
          }
        }
      } else {
        const mainArea = document.querySelector('.oaExamineAllArea');
        const mainareaWidth = mainArea ? mainArea.offsetWidth : 0;
        const flowshow = 100 - (this.flowshow===1 ? 24 : 0)
        const aiWidth = this.robotConfig && Object.keys(this.robotConfig).length && Number(this.robotConfig.fill.aiBoxWidth) !== 100
            ? `${(mainareaWidth * (Number(this.robotConfig.fill.aiBoxWidth) / 100)) / 2}`: '0'
        return 'width:calc(' + flowshow + '% - ' + (this.isAi && (this.isAi === 1 || this.isAi === 3) && this.aiStatus ? aiWidth : 0) + 'px)'
      }
    },
    upAi (val) {
      // this.$set(this, 'isAi', val)
      this.isAi = val
    },
		// 剪切
		cut(msg) {
      console.log(msg)
      if (msg.search('，') !== -1) {
        return
      }
      let text = ''
      let resolution = ''
      let style = ''
      let arr = msg.split(',')
      for (let i = 0; i < arr.length; i++) {
        let check = arr[i].search('：')
        let key = ''
        let value = ''
        if (check !== -1) {
          key = arr[i].substr(0, check)
          value = arr[i].substr(check + 1, arr[i].length)
        } else {
          let _check = arr[i].search(':')
          if (_check !== -1) {
            key = arr[i].substr(0, _check)
            value = arr[i].substr(_check + 1, arr[i].length)
          } else {
            return
          }
        }
        switch (key) {
          case '描述':
            text = value
            break
          case '分辨率':
            resolution = value
            break
          case '风格':
            style = value
            break
        }
      }
      return {
        text: text,
        resolution: resolution,
        style: style
      }
    },
    // 初始化 ai
    async getAi () {
      if (window.localStorage.getItem('authorization')) {
        const { data} = await getLogin()
        if (data.code === 200) {
          this.addTalkAi(data.data.userId)
        } else {
          this.$message.warning('ai链接失败，请咨询管理员！')
        }
      } else {
        const { data } = await loginAi()
        if (data.code === 200) {
          window.localStorage.setItem('authorization', data.data.token)
          window.localStorage.setItem('talkId', data.data.talkId)
          window.localStorage.setItem('userId', data.data.userId)
          this.addTalkAi(data.data.userId)
        } else {
          this.$message.warning('ai链接失败，请咨询管理员！')
        }
      }
    },
		// 初始化文言一心
		async getWYYX(){
			const usertoken = JSON.parse(localStorage.getItem('user')).accesstoken
			getRobotToken(usertoken).then(res=>{
				console.log(res)
				if (res.data.code === 0) {
					window.localStorage.setItem('wxAuthorization', res.data.data)
				} else {
					this.$message.warning('ai链接失败，请咨询管理员！')
				}
			})
		},
    // 过滤掉<think>标签内容
      extractThinkContent(str) {
      return str.replace(/<think>[\s\S]*?<\/think>/gi, '');
    },
		// 时间处理
    getMillisecond(time) {
      if (time == 0) {
        return 0
      }
      if (time.search('s') !== -1) {
        return parseInt(time.substr(0, time.length - 1)) * 1000
      }
      if (time.search('m') !== -1) {
        return parseInt(time.substr(0, time.length - 1)) * 1000 * 60
      }
      if (time.search('h') !== -1) {
        return parseInt(time.substr(0, time.length - 1)) * 1000 * 60 * 60
      }
    },
    // 添加会话列表
    async addTalkAi (userId) {
      const res = await addTalk({
        name: this.approvalId + generateMathRandom([]),
        userId: userId
      })
      if (res.data.code === 200) {
        console.log('添加会话列表')
        window.localStorage.setItem('talkId', res.data.data.talkId)
				console.log('talkid=>',res.data.data.talkId)
        this.talkId = res.data.data.talkId
      } else {
          this.$message.warning('ai链接失败，请咨询管理员！')
        }
    },
    copyToClipboard(content) {
			if (typeof content === 'object') {
        content = content.imgUrl
      }
      const self = this

      if (window.clipboardData) {
        window.clipboardData.setData("text", content);
        self.$message.success('复制成功！')
      } else {
        (function(content) {
          document.oncopy = function(e) {
            e.clipboardData.setData("text", content);
            e.preventDefault();
            document.oncopy = null;
            self.$message.success('复制成功！')
          };
        })(content);
        document.execCommand("Copy");
      }
    },
    //- 表单主弹框点击关闭
    closeDialog () {
      this.dialogAuditVisible = false;
      this.blockchainReadyShow = false;
      this.blockchainDomShow = false;
      this.blockchainLoading = false;
      this.$emit('close')
    },
    onFlowshow () {
      this.flowshow = this.flowshow ? 0 : 1;
    },
    //- 判断是否上传区块链
    gettampering () {
      axiosBase(
        {
          approvalId: this.AuditData.approving.approvalId,
          approvingId: this.AuditData.approvingId
        },
        "/openapi/gettampering"
      ).then(res => {
        if (res.code === 0) {
          //- 显示区块链数据状态
          console.log("gettampering", res);
          this.blockchainStuts = res.data === true ? 1 : 2;
        }
      });
    },
    blockchainReadyFun () {
      // this.dialogAuditVisible = false;
      this.blockchainReadyShow = true;

      this.blockchainLoading = false;

    },
    //- 前往数据对比页面
    goPage () {
      this.blockchainLoading = true;
      setTimeout(() => {
        this.blockchainDomShow = true;
      }, 3000)
    },
    // 发起结束刷新
    retRefresh () {
      console.log("重新提交刷新");
      this.$emit("sourceAudit", {isUp:true, key: 1});
      if (this.open) {
        this.AuditOpenList(this.refreshTemp)
      }
    },
    // 关闭发起弹窗
    inputClose () {
      this.isInput = false;
    },
    onLookQrcodeCommand (command) {
      let commandObj = {
        type: 1,
        channel: command == 1 ? 'mini' : 'h5',
        mode: 'look',
        approvingId: this.AuditData.approvingId,
        approvalId: this.AuditData.approving.approvalId,
        userApprovingId: this.AuditData.userapprovingId,

      }
      this.dialogvueqr = true
      this.$nextTick(function(){
        this.$refs.vueqrcoderef.onQrcodeCommand(commandObj)
      })
    },
    //二维码生成方式
    onQrcodeCommand (command) {
      let commandObj = {
         type: command,
         approvingId: this.AuditData.approvingId,
         approvalId: this.AuditData.approving.approvalId
      }
      this.dialogvueqr = true
      this.$nextTick(function(){
        this.$refs.vueqrcoderef.onQrcodeCommand(commandObj)
      })
    },
    //- 批量导出附件是否显示判断
    panduanShow () {
      let approvalId = this.$route.query.approvalId;
      if (
        approvalId != 10288 &&
        approvalId != 10318 &&
        approvalId != 10156 &&
        approvalId != 10249
      ) {
        return true;
      } else {
        return false;
      }
    },
    // 告知内容跳页
    upLookFun (e) {
      this.lookUpDataPage = e;
      this.bottomLook();
    },
    approvalProcess1 (val, item) {
      const idx = val.approsel
      // 测试说这里值和 4  的反了，现在调换一下
      const approver = val.approving.approver
      const step = val.step
      if(!approver) return "转 办"
      const cur = approver[step] || {}
      if (!item) {
        return "转 办";
      } else {
        if (cur.customStatus) {
          return cur.customStatus
        } else {
          return item[idx] && item[idx].length > 3 ? item[idx][3] : "审批中";
        }
      }
    },
    approvalProcess2(val, item) {
      const idx = val.approsel
      // 测试说这里值和 4  的反了，现在调换一下
      const approver = val.approving.approver
      const step = val.step
      if(!approver) return "同 意"
      const cur = approver[step] || {}
      if (cur.customText) {
        return cur.customText.agree.showText
      }
      if (!item) return "同 意";
      if (idx === -1) {
        return item[item.length - 1][0]
      }else {
        return item[idx][0];
      }
    },
    approvalProcess3(val, item) {
      const idx = val.approsel
      // 测试说这里值和 4  的反了，现在调换一下
      const approver = val.approving.approver
      const step = val.step
      if(!approver) return "拒绝"
      const cur = approver[step] || {}
      if (cur.customText) {
        return cur.customText.refused.showText
      }
      if (!item) return "拒绝";
      if (idx === -1) {
        return item[item.length - 1][1]
      } else {
        return item[idx][1];
      }
    },
    approvalProcess4 (val, item) {
      const idx = val.approsel
      const approver = val.approving.approver
      const step = val.step
      if(!approver) return "转办"
      const cur = approver[step] || {}
      if (idx === -1) {
        return "转办";
      }
      if (!item) return cur.customStatus
      if (idx !== -1) {
        return item[idx][2];
      }
    },
    upRecord (e) {
      this.$refs.dialogRecord.receive(e);
    },
    widgetOneLayerEmitFun (e) {
      console.log("不知道干什么的", e);
    },
    //获取审批按钮列表
    getButtonList (val) {
      axiosBase({approvalId: val.approvalId || val.approving.approvalId}, "/api/getapprovalselection").then(res => {
        if (res.code === 0) {
          for (let i in res.data) {
            res.data[i] = res.data[i].split("|");
          }
          this.buttonList = res.data;
        }
      })
    },
    //文字匹配
    momFun (e) {
      if (e !== undefined) {
        let reg = new RegExp("办理中");
        let reg1 = new RegExp("会签");
        if (reg.test(e) || reg1.test(e)) {
          return "";
        } else {
          return "";
        }
      }
    },
    loadingFun (e) {
      this.fullScreenLoading = e;
    },
    urgent (e, id, name) {
      console.log("催办点击", e, id, name);
      this.$refs.oaExamineUrgent.getUrgent(e, id, this.AuditData.appname);
    },
    urgents ({ e, id, name }) {
      this.urgent(e, id, name)
    },
    subComment (e) {
      if (e && e.isUp) {
        //我办理的-待我办理的（这个状态回来的数据可能会影响到我发起的那块，所以给一个同意更新表示）
        this.$emit("sourceAudit", e)
        if (this.tableStyleField.approvalClosePop) {
          this.AuditOpenList(this.refreshTemp)
        } else {
          this.dialogAuditVisible = false;
        }
        return false;
      }
      const obj = {
        curpage: 0,
        pagesize: 0,
        approvingId: this.auditArr.item.approving.approvingId,
        approvalId: this.auditArr.item.approvalId
      };
      // 从空间进入，需要传空间id
      if(this.isSpace){
        obj.spaceid = this.spaceId
      }
      else if (this.isUpace) {
        obj.upaceid = this.upaceId
      }
      this.getuserapprovinglist(
        obj,
        "process",
        this.auditArr.key
      ).then(()=>{
        this.$nextTick(() => {
          this.$refs.detailCount.init()
        })
      })
      // this.AuditOpenList(this.auditArr.item, this.auditArr.key);
      if (e) {
        this.$emit("sourceAudit", e);
        this.dialogAuditVisible = false;
      }
    },
    orgneFun (res) {
      if (typeof res == "string") {
        return res.split(",");
      } else {
        return res;
      }
    },
    splitOrgname (res) {
      if (res) {
        return res.split(",");
      }
    },
    // 时间戳转成时间
    formatTimestamp(timestamp) {
      if (!timestamp) return '';
      const date = new Date(timestamp);
      return formatDate(date, "yyyy-MM-dd hh:mm");
    },
    replaces (content) {
      return content.replace(/\n/g, "<br />");
    },
    removeDomain (item) {
      var index = this.fastReplyData.indexOf(item);
      if (index !== -1) {
        this.fastReplyData.splice(index, 1);
      }
    },
    addDomain () {
      this.fastReplyData.push({
        value: "",
        key: Date.now()
      });
    },
    createFilter (queryString) {
      return restaurant => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    handleSelect (item) {
      console.log("1:" + item);
    },
    showNotefile (fileurl) {
      this.$refs.widgetOneLayerRef.file_pvw({url:fileurl});
    },
    downNotefile (fileurl) {
      this.$refs.widgetOneLayerRef.handleFileDown({url:fileurl});
    },
    BatchFileName (name) {
      return BatchFileName(name);
    },

    //初始化页面
    AuditOpenList (item, key) {
      //key:  数字字段，只读需要修改状态，1全校数据不需要显示控制按钮
      //item {approving:{approvingId:1111},userapprovingId:2222222,userccappId:123}
      //userccappId 这个如果存在，则代表是告知的
      //layout 两列四列布局
      // 重置
      console.log(item,'itemitemitem')
      this.isOpenTheme = false
      this.printConfig = []
      this.isCustomPrint = false
      this.isOpenFlow = false
      this.ruleList = [];
      this.layout = 2;
      if (this.comment) delete this.comment;
      this.lookUpDataPage = 1;
      this.AuditData = null;
      this.AuditList = null;
      this.formdata = null;
      this.printFormdata = null
      this.isCustom = false
      this.customInputAppInfo = {}
      this.isFiexdCanvas = false
      this.customCanvasIndex = 0
      this.tempformdata = {}
      this.workshopFormdata = {}
      // this.othersFormdata = null;
      this.othersObj = {};
      this.openLoading = true
      // 唯一值 id 暂用
      this.temporaryUse = item;

      this.refreshTemp = item
      this.isInit = true;
      this.auditArr.key = key;
      this.isAi = 0
      this.pageType = (this.dialogInfo && this.dialogInfo.pageType ? this.dialogInfo.pageType : item.pageType )|| ''
      if(item.appAgentConfig){
        this.appAgentConfig = item.appAgentConfig
        this.pageSetPopupStyle = 'simple'
      }
      // 官网不用显示流程
      if(!this.websiteSwitch){
        //获取审批列表（不带参数）
        this.getButtonList(item);
      }
      if(!this.open){
        this.dialogAuditVisible = true; // 显示弹窗
      }
      this.fullScreenLoading = true; // 显示加载进度条
      if(this.websiteSwitch) {
        this.getData(item)
        this.addRead(item)
        this.fullScreenLoading = false;
        return
      }
      if (key === 4 && item.status !== 1) {
        this.upUserccapproving(item.userccappId);
      }
      // 第二个参数 date 数据 process 流程
      const obj = {
        curpage: 0,
        pagesize: 0,
        userapprovingId: item.userapprovingId,
        approvalId: item.approvalId||item.approving.approvalId
      }

      const _obj = {
        curpage: 0,
        pagesize: 0,
        approvingId: item.approving.approvingId,
        approvalId: item.approvalId||item.approving.approvalId
      }
      // 从空间进入，需要传空间id
      if(this.isSpace){
         obj.spaceid = this.spaceId;
        _obj.spaceid = this.spaceId;
      }
      else if(this.isUpace){
        obj.upaceid = this.upaceId;
        _obj.upaceid = this.upaceId;
      }
      if (item.userapprovingId) {
        // 说明开启了流程
        this.isOpenFlow = true
        this.getuserapprovinglist(
          obj,
          "date",
          key,
          item.userccappId,
          item.userapprovingId
        ); // 加一个参数下去 userapprovingId 负数为告知
      } else {
        // 说明没开启流程
        this.isOpenFlow = false
        this.getapproving(item)
      }
      this.getuserapprovinglist(
        _obj,
        "process",
        key
      );
      this.addRead(item)
      // 判断是否存在删除和查看日志权限(产品确认，如果是非个人或者全部数据进来的话，暂时考虑匹配哪个权限)
      this.sUpdate = item.update
      if (item.delete || item.myoplog) {
        this.sDetel = item.delete
        this.sMyoplog = item.myoplog
      }
    },
    async addRead(item) {
      const param = {
        approvalId: item.approvalId || item.approving.approvalId,
        approvingId: item.approving.approvingId,
        type: 'read'
      }
      let api = openapiAddreordcount
      if (this.skey) {
        param.skey = this.skey
        api = outaddreordcount
      }
      await api(param)
    },
    //拆分流程和获取数据
    async getuserapprovinglist (val, item, key, userccappId, userapprovingId) {
      const res = await openapiGetuserapprovinglist(val).catch(error => {
          console.log("解析出错", error, item);
          this.openLoading = false
      })
      this.approvalIs = false; //设置默认值
      if (res.code === 0) {
        if (res.data && res.data[0] && res.data[0].customtitle) {
          this.curUserId = res.data[0].userId
          if (res.data[0].customtitle) {
            this.newsTitle = res.data[0].customtitle.filter(item => { return item.value }).map(item => { return item.value }).join('-')
          }
          if (res.data[0].approving) {
            this.customNewsTitle = res.data[0].approving.appname
          }
        }
        if (item === "date") {
          if (val.userapprovingId !== this.temporaryUse.userapprovingId) {
            console.log(
              "不是一样的",
              val.userapprovingId,
              this.temporaryUse.userapprovingId
            );
            return false;
          }
          console.log('旧接口的数据',res.data[0]);
          let date = res.data[0];
          // 告知范围可见
          if(Object.prototype.hasOwnProperty.call(date, 'rangeOpen')){
            this.ctoShow = date.rangeOpen;
          }

          if (date.approving.formdata)
            date.approvingFormdata = JSON.parse(
              JSON.stringify(date.approving.formdata)
            );

          date.avatar = {
            realname: date.name
          };
          // 获取通知对象列表
          if (date.approving.approvalCcRecord){
            const auditList = JSON.parse(date.approving.approvalCcRecord)
            this.checkedArrUser = []
            this.checkedFlowArr = []
            this.checkedRoleArr = []
            this.checkedGroupArr = []
            auditList.forEach((item, i) => {
              if(i >= 30) return;
              if (item.userId) {//- 用户
                this.checkedArrUser.push({
                  realname: item.realname || item.name,
                  userId: item.userId,
                  orgname: item.orgname
                });
              } else if (item.organizationId) {//- 组织
                this.checkedFlowArr.push({
                  name: item.realname || item.name,
                  organizationId: item.organizationId
                });
              } else if (item.roleId) {//角色
                this.checkedRoleArr.push({
                  roleId: item.roleId,
                  name: item.name || item.realname
                })
              } else if (item.folderId) { // 分组
                this.checkedGroupArr.push({
                  folderId: item.folderId,
                  name: item.name || item.realname
                })
              }
            })
          }
          if (date.pic) date.avatar.logo = date.pic;
          // if (key === 1) {
          //   date.type = 9;
          // }
          this.auditArr.item = date;
          if (userccappId) {
            date.userccappId = userccappId;
          }
          if (userapprovingId) {
            date.userapprovingId = userapprovingId;
            if(date.returnto){
              this.returnto = date.returnto
            }
          }
          this.endStart = date.status && date.status !== 0
          this.AuditData = date;
          this.getApproval();
          if (this.AuditData && this.AuditData.approving.cochain === 2) {
            //- 判断是否上传区块链
            this.gettampering();
          } else {
            //- 还原区块链显示状
            this.blockchainStuts = 1;
          }

          // 暂用的用完了，清除掉
          delete this.temporaryUse;
        } else {
          console.log("拆分流程数据", res.data);
          this.AuditList = res.data;
          // 获取默认字段的数据
          const defaultKey = {}
          if (this.AuditList && this.AuditList[0]) {
            const defaultKeyList = ['申请人_relation-user', '单号_text', '状态_status', '提交时间_date', '归档状态_status']
            defaultKeyList.forEach(item => {
              defaultKey[item] = DealPrintData.handleDefaultKey(item, this.AuditList[0])
            })
          }
          this.formdata = { ...this.formdata, ...defaultKey }

        }
        if (!this.temporaryUse && this.AuditList && this.AuditData)
          this.openLoading = false
          this.fullScreenLoading = false;
      }
    },
    async getapproving(item) {
      const data = await axiosBase({ approvalId: item.approvalId || item.approving.approvalId, approvingId: item.approving.approvingId, person: 1 }, '/api/getapproving')
      if (data.code === 0) {
        const date = data.data
        if(Object.prototype.hasOwnProperty.call(date, 'rangeOpen')){
          this.ctoShow = date.rangeOpen;
        }
        if (date.formdata)
          date.approvingFormdata = JSON.parse(
            JSON.stringify(date.formdata)
          )

        date.avatar = {
          realname: date.name
        }
        if (date.pic) date.avatar.logo = date.pic;
        // if (key === 1) {
        //   date.type = 9;
        // }
        this.auditArr.item = date;
        if (item.userccappId) {
          date.userccappId = item.userccappId;
        }
        if (item.userapprovingId) {
          date.userapprovingId = item.userapprovingId;
          if(date.returnto){
            this.returnto = date.returnto
          }
        }
        this.endStart = date.status && date.status !== 0
        this.AuditData = date;
        this.getApproval();
        if (this.AuditData && this.AuditData.approving.cochain === 2) {
          //- 判断是否上传区块链
          this.gettampering();
        } else {
          //- 还原区块链显示状
          this.blockchainStuts = 1;
        }

        // 暂用的用完了，清除掉
        delete this.temporaryUse;
        if (!this.temporaryUse && this.AuditList && this.AuditData) {
          this.openLoading = false
          this.fullScreenLoading = false;
        }
      }
    },
    // 告知已读未读
    upUserccapproving (val) {
      openapiUpdateuserccapproving({ status: 1, userccappId: val })
        .then(res => {
          if (res.code === 0) {
            this.AuditData.status = 1;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 官网获取数据
    getData(val){
      this.AuditData = val
      getapprovaldetail({
        approvalId: val.approving.approvalId,
        approvingId: val.approving.approvingId,
        skey: this.skey
      }).then(async res => {
        this.approvalIs = false; //设置默认值
        if (res.code === 0) {
          // 是否开启新闻标题
          this.isNews = res.data.iscustom === 1 ? true : false
          if (res.data.listconfig) {
            const listconfig = JSON.parse(res.data.listconfig)
            if (listconfig.other) {
              this.otherConfig = listconfig.other
            }
          }
          if (res.data.customtitle) {
            this.newsTitle = res.data.customtitle.filter(item => { return item.value }).map(item => { return item.value }).join('-')
          }
          if (res.data.approving) {
            this.customNewsTitle = res.data.approving.appname
          }
          this.AuditData.approving.approvalId = val.approving.approvalId
          this.AuditData.approvingId = val.approving.approvingId
          this.AuditData.approvingFormdata = res.data.formdata
          this.openLoading = false
          this.templateFun(res.data)
          this.pdwidth = res.data.pdwidth || 75
          // pc弹窗高度设置
          if (res.data.pdheight) {
            this.pdheight = res.data.pdheight
          }
          if (res.data && res.data.pageset) {
            let pageSet
            pageSet = JSON.parse(res.data.pageset)
            if (pageSet && pageSet.url) {
              pageSet = await getConfigFromUrl(this.$url + pageSet.url)
            }
            if (!Array.isArray(pageSet)) {
              console.log("详情页配置格式错误：", pageSet)
            }
            console.log(pageSet, '外网的自定义配置')
            if (this.pageType !== 'default' && pageSet && pageSet[0].config[1].custom) {
              const customType = pageSet[0].config[1].custom
              let index = customType === 1 ? 1 : 0
              // 1 是自定义 2是使用提交页面的配置
              if (this.pageType === 'custom') {
                index = 1
              } else if (this.pageType === 'add-custom') {
                index = 0
              }
              this.pageSet = pageSet[0].config[index].content ? isJSON(pageSet[0].config[index].content) : {}
              if (this.pageSet.canvasType === 'fixedCanvas') {
                this.isFiexdCanvas = true
                let orders
                if (this.AuditList && this.AuditList[0]) {
                  orders = this.AuditList[0].orders
                }
                this.customInputAppInfo = await getOtherAppConfig(this.pageSet, { isModify: false, isLook: true, orders, skey: this.skey })
              } else {
                this.isCustom = true
                this.templateFun(res.data);
                // 详情页的弹窗样式
                const popupStyle = pageSet[0].config[2].popupStyle ? pageSet[0].config[2].popupStyle : 'default'
                this.pageSetPopupStyle = popupStyle
                if (this.pageSet.dataSource.formList && this.pageSet.dataSource.formList.length>0) {
                  this.getWebsiteOtherApproval(this.pageSet)
                }
              }
            }
          }
        }
      }).catch(err => {
        console.log(err,);
        this.openLoading = false
      })
    },
    //这里获取模板的解析数据
    getApproval () {
      let date = {
        approvalId: this.AuditData.approving.approvalId
      };
      console.log("模板请求", this.AuditData);
      if (this.AuditData.userccappId || this.AuditData.userapprovingId < 0) {
        date.userCcApprovingId = this.AuditData.userccappId
          ? this.AuditData.userccappId
          : Math.abs(this.AuditData.userapprovingId);
      } else {
        if (this.isOpenFlow) {
          date.userApprovingId = this.AuditData.userApprovingId
            ? this.AuditData.userApprovingId
            : this.AuditData.userapprovingId;
        } else {
          date.flow = 1
        }
      }
      if (this.isUpace) {
        let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
        date.upaceid = upaceId
      }
      openapiGetapproval(date)
        .then(async res => {
          if (res.code === 0) {
            // 是否开启新闻标题
            this.isNews = res.data.iscustom === 1 ? true : false
            if (res.data.listconfig) {
              const listconfig = JSON.parse(res.data.listconfig)
              if (listconfig.other) {
                this.otherConfig = listconfig.other
              }
            }
            if (res.data.variableconfig) {
              this.appCustomData = JSON.parse(res.data.variableconfig)
            }
            let pageSet = ''
            // 页面设计的
            if (res.data && res.data.pageset) {
              pageSet = JSON.parse(res.data.pageset)
              if (pageSet.url) {
                pageSet = await getConfigFromUrl(this.$url + pageSet.url)
              }
              console.log(pageSet, this.pageType, '内网的自定义配置')
              // 检测是否是自定义页面
              if (this.pageType !== 'default' && pageSet && pageSet[0].config[2].custom) {
                const customType = pageSet[0].config[2].custom
                let index = customType === 1 ? 2 : 0
                if (this.pageType === 'custom') {
                  index = 2
                } else if (this.pageType === 'add-custom') {
                  index = 0
                }
                if (customType === 3 && pageSet[0].config[2].aiPage) {
                  this.isHtml = true
                  this.htmlInfo.url = `${this.$imgurl}/previewfiles/${pageSet[0].config[2].aiPage.pageUrl}?accesstoken=${this.user.accesstoken}`
                }
                // 1 是自定义 2是使用提交页面的配置
                this.pageSet = pageSet[0].config[index].content ? isJSON(pageSet[0].config[index].content) : {}
                if (this.pageSet.canvasType === 'fixedCanvas') {
                  this.isFiexdCanvas = true
                  let orders
                  if (this.AuditList && this.AuditList[0]) {
                    orders = this.AuditList[0].orders
                  }
                  this.customInputAppInfo = await getOtherAppConfig(this.pageSet, { isModify: false, isLook: true, orders })
                } else {
                  this.isCustom = true
                  this.templateFun(res.data);
                  // 详情页的弹窗样式
                  const popupStyle = pageSet[0].config[2].popupStyle ? pageSet[0].config[2].popupStyle : 'default'
                  this.pageSetPopupStyle = popupStyle
                }
              }
              // 检测是否开启主题设计
              if (pageSet && pageSet.length > 2 && pageSet[2].pc) {
                this.themeConfig = pageSet[2].pc
                this.isOpenTheme = true
              }
              // 打印的配置
              if (pageSet && pageSet[3]) {
                const { printConfig, isShowDefaultPrint, defaultPrintShowKey } = pageSet[3]
                // 检测是否开启自定义打印
                if (printConfig && printConfig.length > 0) {
                  const resArr = printConfig.filter(e => {
                    return e.isShow
                  })
                  if (resArr.length>0) {
                    this.printConfig = resArr
                    this.isCustomPrint = true
                  }
                }
                // 是否显示默认按钮
                if (isShowDefaultPrint !== undefined) {
                  this.isShowDefaultPrint = isShowDefaultPrint
                }
                // 是否有默认报表的打印字段配置
                if (defaultPrintShowKey !== undefined) {
                  this.defaultPrintShowKey = defaultPrintShowKey
                }
              }
            }
						if(res.data.robot) {
              let robots = []
              try {
                robots = JSON.parse(res.data.robot)
              } catch (e) {
                robots.push(res.data.robot)
              }
              // this.$set(this, 'robots', robots)
              // this.$set(this, 'robot', robots[0])
              this.robots = robots
              this.robot = robots[0]
              // this.robots = JSON.parse(res.data.robot)
            }
            if (res.data.opensafe) this.opensafe = res.data.opensafe
            if (res.data.appfile) this.appfile = JSON.parse(res.data.appfile)
            if (res.data && res.data.variableconfig) {
              const customData = JSON.parse(res.data.variableconfig)
              this.customData = await this.setParams({ customData: customData }, null, true)
            }
            this.setDiaSize(res.data)
            if (res.data.todo || res.data.todo === 0) this.reminder = res.data.todo === 1
            if (res.data.turnto) {
              const turnto = JSON.parse(res.data.turnto)
              this.transfer = turnto.open === 1
              this.transferConfig = turnto.depts
              // 如果全局未开启转办，则查询当前审批环节是否有开启
              setTimeout(() => {
                if(!this.transfer && JSON.stringify(this.returnto !== '{}')){
                  let isReturn = false; // 是否转办过来的
                  let _uid = null //获取当前审批环节的uid，并且遍历找到审批流程里对等的userId(可能存在多个审批人，因此改成这么判断)
                  if(this.AuditList && this.AuditList.length > 0){
                    for(let i = 0; i < this.AuditList.length; i++){
                      if(this.AuditList[i].userapprovingId === this.AuditData.userapprovingId){
                        _uid = this.AuditList[i].uid
                      }
                    }
                    this.AuditList.forEach((item) => {
                      if(item.userId === _uid && item.way === 4){
                        isReturn = true;
                        return false;
                      }
                    })
                }
                  // 同时判断转办是否开启，并且二次转办是否开启（如果未开启，只能转办一次）
                  if(Object.prototype.hasOwnProperty.call(this.returnto, 'open')){
                    this.transfer = (this.returnto.open === 1 && this.returnto.againReturn) || this.returnto.open === 1 && (!this.returnto.againReturn && !isReturn)
                  }
                  else if(Object.prototype.hasOwnProperty.call(this.returnto, 'returnto') && Object.prototype.hasOwnProperty.call(this.returnto.returnto, 'open')){
                    this.transfer = (this.returnto.returnto.open === 1 && this.returnto.returnto.againReturn) || this.returnto.returnto.open === 1 && (!this.returnto.returnto.againReturn && !isReturn)
                  }
                  this.transferConfig = Object.prototype.hasOwnProperty.call(this.returnto, 'depts') ? this.returnto.depts : Object.prototype.hasOwnProperty.call(this.returnto, 'returnto') && Object.prototype.hasOwnProperty.call(this.returnto.returnto, 'depts') ? this.returnto.returnto.depts : ''
                }
              }, 1000);
            }
            // 标题字体
            this.tipsize = res.data.tipsize || 14

            if (res.data.permissionlist.length > 0) {
              res.data.permissionlist.forEach((item) => {
                if (item.key === "chaindatacontrastid") {
                  //- 判断是否区块链数据对比按钮是否显示
                  this.blockchainShow = true;
                }
              });
            }
            if (res.data.install) {
              //是否有验证规则
              let install = JSON.parse(res.data.install);
              if (install.addCheckNameUnique)
                this.tipsIs = install.addCheckNameUnique.tipsIs;
            }
            if (res.data.baseset) {
              const baseset = JSON.parse(res.data.baseset)
              if (!baseset.flowshow) baseset.flowshow = { type: 'merge', width: '345px' }
              if (Object.prototype.hasOwnProperty.call(baseset.flowshow, 'onlyUser')) {
                this.onlyUser = baseset.flowshow.onlyUser
              }
              this.baseSet = baseset
            }
            //如果开启了AI小易
            const robotConfig = (typeof res.data.robot == "string") ? JSON.parse(res.data.robot) : res.data.robot
            console.log("res.data.robot==",robotConfig);
            if (robotConfig && !Array.isArray(robotConfig)) {
              this.robotConfig = robotConfig
              // ai 是否给打开的
              this.isAi = robotConfig.view.openai || 0
            }
            if (res.data.layout) this.layout = res.data.layout;
            this.opencomment = res.data.opencomment || 0
            if (res.data.comment || res.data.comment === 0)
              this.comment = res.data.comment;
              this.flowshow = res.data.flowshow; //是否显示查看审批流程按钮
              this.oqrcore = res.data.oqrcore; //二维码是否开启，没有或者0为不开启1为开启
              if (res.data.oqrcore && res.data.qrcodetypes) this.qrcodetypes = JSON.parse(res.data.qrcodetypes)
              this.lookqrcode = res.data.lookqrcode
              if (res.data.lookqrcode && res.data.lookqrcodetypes) this.lookqrcodetypes = JSON.parse(res.data.lookqrcodetypes)
              this.isTime = res.data.istime ? res.data.istime : 0;
              this.templateFun(res.data);
            //- 判断传阅按钮显示与否
            if (
              res.data.pass == undefined ||
              res.data.pass == null ||
              !res.data.pass
            ) {
              this.pass = 0;
            } else {
              this.pass = res.data.pass;
            }
            // 审批默认显示新版审批ui
            if(this.AuditData.type == 1 && this.AuditData.status == 0){
              if(Object.prototype.hasOwnProperty.call(res.data, 'commenttype') && res.data.commenttype === 1){
                this.commentNewStatus = 0;
                return false;
              }
              else{
                this.commentNewStatus = 1;
                setTimeout(() => {
                  this.commentNewFun();
                }, 1000);
              }
            } else {
              this.commentNewStatus = null
            }

            // if (res.data.linkconfig) {
            //   const linkconfig = JSON.parse(res.data.linkconfig)
            //   this.$set(this, 'linkconfig', linkconfig)
              // 如果只开启了直接打开链接，需要流程也处于结束状态
              // if (linkconfig.link && !linkconfig.terrace && (!pageSet || pageSet[0].config[2].custom !== 1) && this.endStart) {
              //   console.log('直接打开链接')
              //   // 给延迟是为了数据和demo 顺利加载
              //   setTimeout(() => {
              //     this.openLink(this.linkconfig)
              //   }, 10)
              // }
            // }

          } else {
            this.schoolClose(res.msg);
          }
        })
        .catch(error => {
          console.log("模板报错", error);
        });
    },
    // 设置弹窗尺寸
    setDiaSize (config) {
      let pdwidth
      let pdheight
      this.isUsePx = false
      if (this.isFiexdCanvas) {
        const { height, width } = this.pageSet.configList[this.customCanvasIndex].fixedCanvasSize
        pdwidth = width.value
        if (width.type === 'custom') {
          this.isUsePx = true
        }
        pdheight = height.type
      } else {
        pdwidth = config.pdwidth
        pdheight = config.pdheight
      }
      // pc弹窗高度设置
      this.pdwidth = pdwidth || 75
      // pc弹窗高度设置
      if(pdheight){
        this.pdheight = pdheight
        // 如果设置弹窗高度自适应，并且弹窗超出一屏，则设置弹窗高度为屏幕高度
        if(this.pdheight === 'auto'){
          setTimeout(() => {
            const wisdomSubmitEl = document.querySelector('.oaExamineAllArea');
            const wisdomSubmitHeight = wisdomSubmitEl ? wisdomSubmitEl.offsetHeight : 0; // 获取.wisdomSubmit的高度
            const browserHeight = window.innerHeight; // 获取浏览器的高度
            // 如果.wisdomSubmit的高度超出浏览器高度，则修改其高度
            if (wisdomSubmitHeight > browserHeight) {
              wisdomSubmitEl.style.height = browserHeight-220 + 'px'; // 设置.wisdomSubmit的高度为浏览器高度
              if(this.aiStatus && this.isAi !== 0){
                // 获取右侧ai小易高度
                this.examineHeight = browserHeight-220
              }
            }
          }, 500);
        }
      }
    },
    // 官网自定义他表的数据
    getWebsiteOtherApproval(val){
      val.dataSource.formList.forEach(item=>{
        if(item.datatype === 2){
          // 数据工坊
          let data = {
            approvalReportId: item.appid,
            skey: this.skey,
            curpage: 1,
            pagesize: 20,
          }
          getwebsiteapprovalreportdatalist(data).then(res=>{
            if(res.data.list.length>0){
              res.data.list.forEach(item=>{
                const keys = Object.keys(item)
                keys.forEach(key=>{
                  if (this.workshopFormdata[key] === undefined) {
                    this.workshopFormdata[key] = []
                    this.workshopFormdata[key].push(item[key])
                  } else {
                    this.workshopFormdata[key].push(item[key])
                  }
                })
              })
            }
          }).catch(err=>{
            console.log('getapprovalreportdatalist错误：',err)
          })
        } else {
          // 获取他表模板
          const data = {
            approvalId: item.appid,
            skey: this.skey
          }
          if (this.isUpace) {
            let upaceId = typeof(this.$route.query.upaceid) !== 'undefined' ? this.$route.query.upaceid : localStorage.getItem('upaceid')
            data.upaceid = upaceId
          }
          getwebsiteapproval(data).then(res=>{
            if(res.code === 0){
              let ruleListArr = []
              this.ruleList  = [...this.ruleList, ...JSON.parse(res.data.property)]
              JSON.parse(res.data.property).forEach(item=>{
                const name = item.title+'_'+item.type
                ruleListArr.push(name)
              })
              const query = {
                curpage: 0,
                pagesize: 20,
                approvalId: item.appid,
                skey: this.skey
              }
              // 获取他表数据
              getdetailapprovinglist(query).then(res1=>{
                if(res1.code === 0){
                  let list = []
                  res1.data.forEach(x=>{
                    list.push(JSON.parse(x.formdata))
                  })

                  list.forEach(item=>{
                    const keys = Object.keys(item)
                    keys.forEach(key=>{
                      if (this.tempformdata[key] === undefined) {
                        this.tempformdata[key] = []
                        this.tempformdata[key].push(item[key])
                      } else {
                        this.tempformdata[key].push(item[key])
                      }
                    })
                  })
                  this.formdata = {...this.formdata, ...this.tempformdata}
                }
              })
            }
          })
        }
      })
    },
    //模板数据解析
    templateFun (e) {
      if (e.property) {
        console.log("解析模板",e);
        // console.log("解析模板",this.AuditData.approvingFormdata);
        // 模板解析初始值
        let ruleList = JSON.parse(e.property);
        this.appProperty = JSON.parse(e.property);
        if (this.isFiexdCanvas) {
          ruleList = dealInputConfig(this.pageSet.configList[this.customCanvasIndex], cloneDeep(ruleList))
        }
        const approvingFormdata = JSON.parse(this.AuditData.approvingFormdata)
        // 新闻模式切不是自定义的情况下只显示这些控件
        if (this.isNews && !this.isCustom && !this.isFiexdCanvas) {
          const newsField = ['richTextWid', 'textarea', 'file', 'image']
          ruleList = ruleList.filter(item => { return newsField.includes(item.type) })
        }
        let formdata = momVal(JSON.parse(e.property))
        // if (this.linkconfig.open && (this.linkconfig.link || this.linkconfig.terrace)) {
        //   formdata.linktype = this.linkconfig.terrace ? 0 : 1
        // }
        // 对比赋值
        formdata = assignFormdata(
          formdata,
          approvingFormdata
        );

        // console.log("查方法", setOthersFormdata, ruleList, formdata);
        // console.log('结果数据机', setOthersFormdata(this.ruleList, formdata));
        let OthersFormdata = setOthersFormdata(ruleList, formdata);
        this.associationVisible = OthersFormdata.associationVisible;
        formdata = OthersFormdata.formdata;
        this.ruleList = OthersFormdata.template;
        this.othersObj = OthersFormdata.othersObj;
        // 明细数据兼容小程序bug
        for(let key in formdata) {
          if (key.search('details')!== -1) {
            // 明细控件-增加是否填写开关
            const prefix = key.split('_details')[0];
            const fillStatusKey = prefix + '_fillStatus';
            if (!Object.prototype.hasOwnProperty.call(formdata, fillStatusKey)) {
              console.log("approvingFormdata[fillStatusKey]==",approvingFormdata[fillStatusKey])
              if (approvingFormdata && Object.prototype.hasOwnProperty.call(approvingFormdata, fillStatusKey)) {
                formdata[fillStatusKey] = approvingFormdata[fillStatusKey];
              } else {
                formdata[fillStatusKey] = 1;
              }
            }
            formdata[key].forEach(item=>{
              for(let _key in item) {
                if (_key.search('relation-user')!== -1 || _key.search('radio')!== -1) {
                  if (item[_key]) {
                    item[_key] = item[_key].value ? item[_key].value : item[_key]
                  }
                  try {
                    if (_key.search('relation-user')!== -1) {
                      item[_key] = typeof item[_key] == 'string' ? JSON.parse(item[_key]) : item[_key]
                    }
                  }catch(e){
                    console.log('解析错误', e)
                  }
                }
              }
            })
          }
        }
        this.formdata = { ...this.formdata, ...formdata }
        if (this.isFiexdCanvas) {
          this.customInputAppInfo[this.AuditData.approvalId] = {
            formdata: cloneDeep(this.formdata),
            property: cloneDeep(ruleList)
          }
        }
        if (this.isHtml) {
          this.$nextTick(()=>{
            this.sendModeConfig('view', this.formdata)
          })
        }
        // 获取右侧ai小易高度
        setTimeout(() => {
          const examineEl = document.querySelector('.oaExamineLeft')
          // console.log("examineEl==",examineEl.offsetHeight,examineEl);
          if (examineEl && this.isAi !== 0) {
            this.examineHeight = examineEl.offsetHeight
          }
        }, 1000);
      }
    },
    sendModeConfig(mode, data = null) {
      const message = {
        type: 'MODE_CONFIG',
        mode: mode,      // 'edit' 或 'view'
      };
      if (mode === 'view' && data) {
        message.data = JSON.parse(JSON.stringify(data));
      }
      const ref = this.$refs.htmlIframe
      // 确保iframe加载完成后发送 (此处直接发送，若iframe未完全加载，消息也会被缓存；稳妥起见加一个简单延时)
      if (ref && ref.contentWindow) {
        ref.contentWindow.postMessage(message, '*');
      }
    },
    schoolClose (val) {
      let self = this;
      this.$msgbox({
        title: "提示",
        message: val,
        confirmButtonText: "我知道了",
        showCancelButton: false,
        showClose: false,
        type: "warning",
        confirmButtonClass: "yes-buttom"
      }).then(() => {
        self.dialogAuditVisible = false;
      });
    },
    previewPicture (param) {
      this.initialIndex = param.indexImg;
      this.dialogImageUrl = param.dataImg;
      this.dialogVisible = true;
    },
    dialogClose () {
      this.dialogImageUrl = [];
      this.dialogVisible = false;
    },
    previewFile (item) {
      Window.open(item);
    },
    commentNewFun (){
      console.log("审批初始化===")
      let item = 1
      let value = '同意'
      //处理表格是否必填
      const ruleLisTparam = this.$refs.widgetOneLayerRef.widgetOneLayerPullData(
        Number(item) === 1 ? 1 : false
      );
      if (ruleLisTparam.isCheck == 2 && item !== 2) {
        return false;
      }
      //审批同意或者拒绝按钮
      let date = {
        stat: 2, //状态说明（1 评论 2 处理事件说明 3 转办）
        userapprovingId: this.AuditData.userapprovingId,
        formdata: item == 2 ? undefined : ruleLisTparam.dataList,
        item: item,
        isComment: this.AuditData.iscomment,
        issign: this.AuditData.issign,
        text: value
      };
      console.log("1111==")
      this.$nextTick(function(){
        console.log("2222==")
        this.$refs.oaExamineCommentNew.oaExamineCommentFun(date, true);
      })
    },
    auditBtn (item, value) {
      //处理表格是否必填
      const ruleLisTparam = this.$refs.widgetOneLayerRef.widgetOneLayerPullData(
        Number(item) === 1 ? 1 : false
      );
      if (ruleLisTparam.isCheck == 2 && item !== 2) {
        return false;
      }
      //审批同意或者拒绝按钮
      let date = {
        stat: 2, //状态说明（1 评论 2 处理事件说明 3 转办）
        userapprovingId: this.AuditData.userapprovingId,
        formdata: item == 2 ? undefined : ruleLisTparam.dataList,
        item: item,
        isComment: this.AuditData.iscomment,
        issign: this.AuditData.issign,
        text: value
      };
      /**
       * 以下是进提醒可提交规则，由于审批的时候，后台无法判断是否本人提交，都进行验证
       * 导致了数据没有重复也提示重复，所以孙决定不验证这个规则，后续需要验证，就把注释打开，最后一个
       * this.$refs.oaExamineComment.oaExamineCommentFun(date)删除即可
       */

      // if(this.tipsIs){
      //   let data = ruleLisTparam.dataList
      //   data.approvalId=this.AuditData.approving.approvalId
      //   checkdataunique(data).then(res => {
      //     if(res.code==0&&res.data=='-2') {
      //       //唯一验证的需要修改
      //       this.$store.commit('upOnly', 'true');

      //       this.$confirm(res.msg, '提示', {
      //         confirmButtonClass:'el-button--yeprimary',
      //         confirmButtonText: '确定',
      //         cancelButtonText: '取消',
      //         type: 'warning'
      //       }).then(() => {
      //         this.tipsIs=false;
      //         this.$refs.oaExamineComment.oaExamineCommentFun(date);
      //       });
      //     }else{
      //       this.tipsIs=false;
      //       this.$refs.oaExamineComment.oaExamineCommentFun(date)
      //     }
      //   }).catch(error => { console.log(error) });
      // }else{
      //   this.$refs.oaExamineComment.oaExamineCommentFun(date)
      // }
      // this.$refs.oaExamineComment.oaExamineCommentFun(date, true);
      if(this.commentNewStatus === 0){
        this.$refs.oaExamineComment.oaExamineCommentFun(date, true);
      }
      else{
        console.log("3333==")
        this.$refs.oaExamineCommentNew.oaExamineCommentFun(date, true);
        this.$refs.oaExamineCommentNew.subComment()
      }
    },
    //撤销
    cancel (item) {
      let self = this;
      this.$confirm("确定处理?", "提示", {
        confirmButtonClass: "el-button--yeprimary",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let data = {
          status: item,
          userapprovingId: this.AuditData.userapprovingId
        };
        if (this.$route.query.spaceid) {
          data.spaceid = this.$route.query.spaceid
        }
        else if (this.$route.query.upaceid) {
          data.upaceid = this.$route.query.upaceid
        }
        openapiUpdateuserapproving(data)
          .then(res => {
            console.log(res);
            if (Number(res.code) === 0) {
              self.$message({
                type: "success",
                message: "撤销成功"
              });
              self.$emit("sourceAudit", { key: 1 });
              self.AuditData.status = 3;
              /*
            this.resubmit(this.AuditData)
            this.dialogAuditVisible = false
            */
            } else {
              self.$message({
                type: "error",
                message: res.msg
              });
            }
          })
          .catch(error => {
            console.log(error);
          });
      });
    },
    resubmit (item) {
      if (item.resubmit) {
        this.inputObj = {
          approvalId: item.approving.approvalId,
          type: 1,
          approvingId: item.approving.approvingId,
          modifyId: item.approving.approvingId,
          person: 1
        };
        // this.modify = {
        //   approvalId: item.approving.approvalId,
        //   type: 1,
        //   modifyId: item.approving.approvingId,
        //   person: 1
        // }
        this.isInput = true;
        let self = this;
        this.$nextTick(function () {
          self.dialogAuditVisible = false;
        });
        // this.dialogAuditVisible = false;
        /*
                  this.$router.push({
                    path: "/clientSide/oaExamine/oaExamineInput",
                    query: { approvalId: item.approving.approvalId,type:1,approvingId:item.approvingId}
                  });
        */
      } else {
        this.$message({
          type: "warning",
          message: "您没有权限"
        });
      }
    },
    review () {
      //点击打开评论框
      let date = {
        stat: 1, //状态说明（1 评论 2 处理事件说明 3 转办）
        userapprovingId: this.AuditData.userapprovingId,
        text: "评论"
      };
      this.$refs.oaExamineComment.oaExamineCommentFun(date);
    },
    approuserMore (value) {
      //查看详情
      this.approuserMoreData = value;
      this.dialogApprouserMore = true;
    },
    lookUp (e) {
      this.isLook = e;
      this.getLookUp(1);
    },
    //头部已读
    topLook (e) {
      let date = {
        approvingId: this.AuditData.approvingId,
        status: 1
      };
      this.dialogLookUpVisibleLoading = true;
      this.dialogLookUpVisible = true;
      console.log("topLook==",e)
      openapiGetapprovinguser(date)
        .then(res => {
          if (res.code === 0) {
            for (let i = 0; i < res.data.read.length; i++) {
              res.data.read[i].orgname = this.splitData(
                res.data.read[i].orgname
              );
            }
            for (let i = 0; i < res.data.unread.length; i++) {
              res.data.unread[i].orgname = this.splitData(
                res.data.unread[i].orgname
              );
            }
            this.LookUpData = res.data;
            this.dialogLookUpVisibleLoading = false;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    //底部已读
    bottomLook (e) {
      //查看阅读人数
      let date = {
        approvalId: this.AuditData.approving.approvalId,
        approvingId: this.AuditData.approvingId,
        status: this.reade,
        curpage: this.lookUpDataPage,
        pagesize: 50
      };
      this.dialogLookUpVisibleLoading = true;
      this.dialogLookUpVisible = true;
      console.log("bottomLook==",e)
      if (this.isSpace){
        date.spaceid = this.spaceId;
      }
      else if (this.isUpace) {
        date.upaceid = this.upaceId
      }
      openapiGetuserccapprovallist(date)
        .then(res => {
          if (res.code === 0) {
            let date = JSON.parse(JSON.stringify(res.data));
            this.LookUpData = {};
            for (let i = 0; i < date.length; i++) {
              res.data[i].organizationNamess = date[i].organizationNames.split(",") || [];
            }
            if (Number(this.reade) === 1) {
              for (let i in res.data) {
                res.data[i].orgname = this.splitData(res.data[i].orgname);
              }
              this.LookUpData.read = res.data;
            } else {
              for (let i in res.data) {
                res.data[i].orgname = this.splitData(res.data[i].orgname);
              }
              this.LookUpData.unread = res.data;
            }
            this.lookUpDataTotal = res.total;
          }
          this.dialogLookUpVisibleLoading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    getLookUp (e) {
      console.log("查看阅读人数", this.isLook, e, this.reade, this.lookUpDataPage);
      this.lookUpDataPage = 1;

      //这里进行判断
      if (this.isLook === 0) {
        this.topLook(e);
      } else {
        this.bottomLook(e);
      }
    },
    splitData (e) {
      if (typeof e == "string") {
        e = e.split(",");
      }
      return e;
    },
    // 流程按钮是否显示
    showFlowButton() {
      console.log("this.onlyUser==",this.onlyUser);
      if (this.onlyUser === 1) {
        const userMsg = JSON.parse(window.localStorage.getItem('userMsg'))
        const userId = userMsg.userId
        console.log("userId==",this.curUserId, userId)
        return this.curUserId === userId && 
               this.flowshow != 2 && 
               this.blockchainReadyShow === false && 
               !this.websiteSwitch
      }
      if (this.onlyUser === 0) {
        return this.flowshow != 2 && 
               this.blockchainReadyShow === false && 
               !this.websiteSwitch
      }
      return false
    },
    flowBtn (item) {
      this.mode = item;
      if (item == 1 || item == 0) {
        //1是转办 (转办要多选，所以分开)
        if (item == 1) {
          const obs = {
            radio_: false,
            isEquired: true,
            isGroup: true,
            onlyUser: true,
            approvalId: this.AuditData.approving.approvalId,
            grouping: this.baseSet.grouping,
          }
          // 组织、角色列表分开显示
          if (this.transferConfig && this.transferConfig.length > 0) {
            const freeList = this.transferConfig;
            let roleArr = [];
            let flowArr = [];
            freeList.forEach(e => {
              if(e.roleId){//角色
                roleArr.push({roleId:e.roleId,name:e.name||e.realname})
              }else{//组织
                flowArr.push({organizationId:e.organizationId,name:e.name||e.realname})
              }
            });
            obs.lookCustomArr = flowArr;
            obs.lookCustomArrRole = roleArr;
          }
          this.$refs.multipleChoiceChild.multipleChoiceMethod(obs);
        } else {
          this.$refs.multipleChoiceChild.multipleChoiceMethod({
            radio_: true,
            isEquired: true,
            isGroup: true,
            approvalId: this.AuditData.approving.approvalId,
            grouping: this.baseSet.grouping,
          });
        }
      } else {
        const obs = {
          isGroup: true,
          approvalId: this.AuditData.approving.approvalId,
          grouping: this.baseSet.grouping,
        }
        // 组织、角色列表分开显示
        if (this.transferConfig && this.transferConfig.length > 0) {
          const freeList = this.transferConfig;
          let roleArr = [];
          let flowArr = [];
          freeList.forEach(e => {
            if(e.roleId){//角色
              roleArr.push({roleId:e.roleId,name:e.name||e.realname})
            }else{//组织
              flowArr.push({organizationId:e.organizationId,name:e.name||e.realname})
            }
          });
          obs.lookCustomArr = flowArr;
          obs.lookCustomArrRole = roleArr;
        }
        this.$refs.multipleChoiceChild.multipleChoiceMethod(obs);
      }
    },
    fromMultipleChoice (param) {
      console.log("param==", JSON.stringify(param));
      //来源multipleChoice.vue的方法
      this.fullScreenLoading = true;
      if (this.mode == 1 || this.mode == 0) {
        //这里弹窗去评论那边
        let date = {
          stat: 3, //状态说明（1 评论 2 处理事件说明 3 转办）
          userapprovingId: this.AuditData.userapprovingId,
          uid: param,
          text: "转办"
        };
        this.$refs.oaExamineComment.oaExamineCommentFun(date, true);
      } else if (Number(this.mode) === 9) {
        console.log("传阅的", this.AuditData, param);
        let date = {
          userapprovingId: this.AuditData.userapprovingId
        };
        if (param.checkedFlowArr) {
          let organizationIds = [];
          param.checkedFlowArr.forEach(item => {
            organizationIds.push(item.organizationId);
          });
          date.organizationIds = organizationIds.join(",");
        }
        if (param.checkedRoleArr) {
          let roleIds = [];
          param.checkedRoleArr.forEach(item => {
            roleIds.push(item.roleId);
          });
          date.roleIds = roleIds.join(",");
        }
        if (param.checkedArrUser) {
          let userIds = [];
          param.checkedArrUser.forEach(item => {
            userIds.push(item.userId);
          });
          date.userIds = userIds.join(",");
        }
        //处理
        openapiApprovingdistribute(date)
          .then(res => {
            console.log(res);
            if (res.code === 0) {
              this.$message({
                type: "success",
                message: "传阅成功"
              });
              this.$emit("sourceAudit", {
                key: 0,
                userapprovingId: this.AuditData.userapprovingId
              });
              this.dialogAuditVisible = false;
              this.fullScreenLoading = false;
            } else {
              this.$message({
                type: "info",
                message: res.msg
                // message: "操作失败!"
              });
              this.fullScreenLoading = false;
            }
          })
          .catch(error => {
            console.log(error);
          });
      } else {
        //这里去评论框
        let paramArr = {
          // comment: this.state3,
          stat: 4, //这个是流转的
          step: this.AuditData.step,
          approvingId: this.AuditData.approvingId,
          userapprovingId: this.AuditData.userapprovingId,
          uid: param,
          text: "流转"
        };
        this.$refs.oaExamineComment.oaExamineCommentFun(paramArr);
      }
    },
    auditPrinting () {
      var auditListData = this.AuditList;
      var stateObj = {};
      var processData = [];
      var applyUser = ""; //申请人
      console.log("auditListData==", auditListData);
      auditListData.forEach((elEm) => {
        var stateData = {};
        //获取数据
        var typeIs = elEm["type"];
        var statusIs = elEm["status"];
        var wayIs = elEm["way"];
        // var realnameIs = elEm["realname"];
        var approselIs = elEm["approsel"]; //处理流程环节-名称
        // var commentIs = elEm["comment"]; //处理流程环节-评论
        var signIs = elEm["sign"]; //处理流程环节-评论
        // 如果statusIs为-1，跳过当前步骤
        if (statusIs == "-1") {
          return;
        }
        //数据构造。判断
        if (wayIs && wayIs == "4") {
          approselIs = this.approvalProcess4(elEm, this.buttonList);
          if (elEm.approuser && elEm.approuser.length > 0)
            stateData.userText = elEm.approuser
              .map(vals => {
                return vals.approname;
              })
              .join(",");
        } else if (wayIs && wayIs == "3") {
          approselIs = this.launchdataPl;
        } else {
          if (typeIs == "0" && statusIs != "3") {
            //发起环节获取申请人
            approselIs = this.launchdata;
            applyUser = elEm.user?elEm.user.realname:''; //申请人
          } else if (typeIs == "0" && statusIs == "3") {
            approselIs = this.launchdataChH;
          } else if (statusIs == "1" && typeIs == "1" && wayIs != "3") {
            approselIs = this.approvalProcess2(elEm, this.buttonList);
          } else if (
            (statusIs == "0" && typeIs == "1" && wayIs != "3") ||
            statusIs == "4"
          ) {
            approselIs = this.approvalProcess1(elEm, this.buttonList);
          } else if (statusIs == "2" && typeIs == "1" && wayIs != "3") {
            approselIs = this.approvalProcess3(elEm, this.buttonList);
          }
        }
        stateData.stateUser = elEm.user?elEm.user.realname:''; //申请人
        if (this.isTime === 0)
          stateData.stateTime = formatDate(
            new Date(elEm.ctime),
            "yyyy-MM-dd hh:mm"
          ); // 处理时间
        stateData.stateName = approselIs; //处理流程
        if (elEm.comment) {
          stateData.stateMain = elEm.comment;
        } else if (elEm.note) {
          stateData.stateMain = elEm.note;
        } else {
          stateData.stateMain = "";
        }
        // 添加签名
        if (signIs) {
          const accesstoken = JSON.parse(localStorage.getItem('user')).accesstoken
          stateData.stateSignIs = `${this.$imgurl}${signIs}?accesstoken=${accesstoken}`
        }

        processData.push(stateData);
      })
      //获取用户信息。学校名称/表头数据
      var loginDataObj = {};
      var affairName = this.AuditData.appname; //事务名称
      var applyDate = this.AuditData.approving.orders; //申请日期
      // var applyDate = this.AuditData.approving.ctime; //申请日期 后台确认换成上面的orders
      //用户信息。 login.vue 缓存
      var schoolName = "";
      let userMsg_external = localStorage.getItem("userMsg_external"); //- 新增外链模式下面的userMsg
      if (userMsg_external) {
        userMsg_external = JSON.parse(userMsg_external);
        schoolName = userMsg_external.schoolMsg.name;
      } else {
        schoolName = this.userMsg.schoolMsg&&this.userMsg.schoolMsg.name;
      }
      loginDataObj.affairName = affairName;
      loginDataObj.applyDate = applyDate;
      loginDataObj.schoolName = schoolName; //学校名
      loginDataObj.applyUser = applyUser;
      //数据结果
      stateObj.processData = processData;
      stateObj.loginDataObj = loginDataObj;
      this.dialogAuditVisible = false;
      //替换数据权限
      const AuditDataOvb = JSON.parse(JSON.stringify(this.AuditData));
      let ruleListArr = JSON.parse(JSON.stringify(this.ruleList));
      const formdata = othersRed(
        this.ruleList,
        copyObj(this.formdata),
        this.othersObj
      );
      const valKey = oaAuditPrintingFunc(ruleListArr, formdata, 1);
      AuditDataOvb.approving.formdata = valKey;
      // 时间值手动替换过去
      AuditDataOvb.istime = this.isTime;
      console.log(AuditDataOvb,stateObj, 'AuditDataOvb');
      console.log("AuditDataOvb==", JSON.stringify(AuditDataOvb));
      this.$refs.oaAuditPrintingChild.oaAuditPrintingChildFun(
        AuditDataOvb,
        stateObj,
        cloneDeep(this.defaultPrintShowKey)
      );
    },
    async customPrinting(index, printId = 0) {

      if(index === 'default') {
        // 默认的打印
        this.auditPrinting()
      } else {
        // 存在 printId 就是内网详情页按钮组件的功能
        if (printId && typeof printId === 'number') {
          index = this.printConfig.findIndex(item => {
            return item.id == printId
          })
        }
        this.printBoxOpen = true

        this.printFormdata = JSON.parse(JSON.stringify(this.formdata))
        this.printTitle = this.printConfig[index].canvasName
        this.printBoxConfig = JSON.parse(JSON.stringify(this.compatibleSheetCongfig(this.printConfig[index])))
        // 判断是否有他表的数据
        if (this.printBoxConfig.dataSource.formList && this.printBoxConfig.dataSource.formList.length>0) {
          const { otherData } = await DealPrintData.getOtherApproval(this.printBoxConfig, this.printFormdata, this.spaceId, this.upaceId)
          if (otherData.deptGroup !== undefined) {
            this.deptGroup = JSON.parse(JSON.stringify(otherData.deptGroup))
            delete otherData.deptGroup
          } else {
            this.deptGroup = {}
          }
          this.printFormdata = { ...this.printFormdata, ...otherData }
        }
        this.printFormdata = await DealPrintData.getRelationUserInfo(this.printFormdata)
        this.printFormdata = await DealPrintData.dealRadioLabel(this.printFormdata, this.ruleList)
        
        console.log(this.printFormdata, '传入的值')
        this.printBoxShow = true

      }
    },
    // 兼容旧的表格数据
    compatibleSheetCongfig (config) {
      let resultConfig = JSON.parse(JSON.stringify(config))

      if (resultConfig.sheetList.length > 0 && resultConfig.sheetList[0].sheets && resultConfig.sheetList[0].sheets.length > 0) {
        const sheetList = resultConfig.sheetList[0].sheets
        // 删除原来配置的 工作表
        delete resultConfig.sheetList[0].sheets
        // 旧的全局配置
        const sheetOldConfig = JSON.parse(JSON.stringify(resultConfig.sheetList[0]))
        sheetList.forEach(item => {
          // 将原来的全局配置分配给每个工作表
          if (resultConfig.sheetConfig === undefined) resultConfig.sheetConfig = {}
          resultConfig.sheetConfig[item.index] = {...sheetOldConfig}
        })
        resultConfig.sheetList = sheetList
      }
      return resultConfig
    },

    //此方法来自  oaAuditPrinting.vue 定义的
    eventPrintingChild (isdata) {
      if (isdata == 1) {
        this.dialogAuditVisible = true;
      }
    },
		// 切换机器人
		async changeRobot(i){
			this.robot = i
			await this.$nextTick()
      this.$refs.scrollArea.wrap.scrollTop = this.$refs.scrollArea.wrap.scrollHeight
		},
		// 机器人盒子Enter事件
		robotBoxEnter(){
			this.boxVisiable = true
		},
		// 机器人盒子leave事件
		robotBoxLeave(){
			this.boxVisiable = false
		},
		// 获取AI小易开启状态
		async getManagementList(){
			const obj = { curpage: 0, pagesize: 0, type: this.abilityType }
      obj.name = '人工智能查询'
      if (this.$route.query.upaceid || (this.$route.query.upace && localStorage.getItem('upaceid'))) {
        obj.upaceid = this.$route.query.upaceid || localStorage.getItem('upaceid')
      }   
			const { data } = await axiosBase(obj, "/api/getcompetencymanagelist")
			console.log(data)
			if(data && data.length !== 0){
				let status = data[0]['status']
				console.log("status==",status)
				this.aiStatus = status ? true : false
			}
		},
    // 新增获取AI区域样式的方法
    getAiAreaStyle() {
      const w = this.flowshow === 1 ? this.baseSet.flowshow.width.substring(0, this.baseSet.flowshow.width.length - 2) : 0
      if(Object.keys(this.appAgentConfig).length !== 0){
        return 'width: 100%'
      }
      // 没开启流程
      if(w === 0){
        return {
          width: this.robotConfig && Object.keys(this.robotConfig).length && Number(this.robotConfig.view.aiBoxWidth) !== 100 ? `${Number(this.robotConfig.view.aiBoxWidth)}%` : '100%',
          height: this.examineHeight ? `${this.examineHeight}px` : 'auto'
        }
      }
      else{
        // 获取主区域总宽度
        const mainArea = document.querySelector('.oaExamineAllArea');
        const mainareaWidth = mainArea ? mainArea.offsetWidth - w : 0;
        if(this.isAi === 2){
          return 'width:0'
        }
        else{
          // 判断是否需要50%宽度
          return this.robotConfig && Object.keys(this.robotConfig).length && Number(this.robotConfig.view.aiBoxWidth) !== 100
            ? `width:${mainareaWidth / 2}px`
            : `width:${mainareaWidth}px`
        }
      }
    },
    // 获取ai名称配置信息
    async getAiName(){
        const res = await getaimanageconfig()
        if (res.code === 0) {
          this.aiConfigList.forEach(ai => {
            res.data.forEach(item => {
              if (ai.number === item.number) {
                ai.name = item.name;
              }
            });
          });
        } else {
            this.$message.error(res.msg);
        }
    },
    startResize(e) {
      this.isResizing = true;
      this.startX = e.clientX;
      this.startWidth = document.querySelector('.ctoAllArea-ai').offsetWidth;
      document.addEventListener('mousemove', this.handleResize);
      document.addEventListener('mouseup', this.stopResize);

      // 添加禁止选择文本的样式
      document.body.style.userSelect = 'none';
    },

    handleResize(e) {
      if (!this.isResizing) return;

      const dx = this.startX - e.clientX;
      let newWidth = this.startWidth + dx;

      // 限制最小和最大宽度
      newWidth = Math.max(this.minWidth, Math.min(newWidth, this.maxWidth));

      // 更新 AI 区域宽度
      document.querySelector('.ctoAllArea-ai').style.width = `${newWidth}px`;

      // 更新主内容区域宽度
      const mainContent = document.querySelector('.oaExamineLeft');
      if (mainContent) {
        mainContent.style.width = `calc(100% - ${newWidth}px)`;
      }
    },

    stopResize() {
      this.isResizing = false;
      document.removeEventListener('mousemove', this.handleResize);
      document.removeEventListener('mouseup', this.stopResize);

      // 移除禁止选择文本的样式
      document.body.style.userSelect = '';
    }
  },
  unmounted () {
    this.$store.commit("upOnly", "false");
    // 清理事件监听
    document.removeEventListener('mousemove', this.handleResize);
    document.removeEventListener('mouseup', this.stopResize);
  },
  mounted() {
    this.skey = this.$route.params.skey || this.$route.query.skey || window.localStorage.getItem('skey')
    // ai内网需要调用人工智能相关接口，因此加个获取skey，排除从缓存获取
    this.skeyNoLocal = this.$route.params.skey || this.$route.query.skey
    if(this.appInfo) {
      this.AuditOpenList(this.appInfo,1)
    }
    const user = localStorage.getItem('user')
    if(user) {
      this.user = JSON.parse(user)
    }
    if (!this.skeyNoLocal) {
      this.getManagementList()
    }
    const that = this
    window.addEventListener('message', (event)=> {
      const message = event.data;
      if (message) {
        if (message.type === 'IFRAME_READY') {
          console.log('[父窗口] 收到 iframe 就绪信号');
          // 此时安全发送模式配置
          that.sendModeConfig('view', that.formdata)
        }
      }
    });
	}
};
</script>
<style>
.timeline-red .el-timeline-item__icon {
  color: #df5d09;
}
.timeline-blue .el-timeline-item__tail,
.timeline-red .el-timeline-item__tail {
  top: 15px;
}
.timeline-blue .el-timeline-item__node,
.timeline-red .el-timeline-item__node {
  top: 15px;
}
.el-timeline-item {
  padding-bottom: 6px;
}
.el-timeline-item__timestamp.is-bottom {
  margin-top: 0;
}

#oaExamineAudit .relation-user .block-tag:hover .el-icon-close {
  background-color: #666666;
}
#oaExamineAudit .relation-user .block-tag .el-icon-close {
  color: #ffffff;
  background-color: #999999;
  width: 16px;
  height: 16px;
  font-size: 12px;
}
#reade .el-dialog__headerbtn {
  z-index: 99999;
}
#reade .el-icon-close {
  color: #000000;
  font-weight: bold;
}
.reade .el-tabs__nav {
  width: 50%;
  margin: 15px 25% 0;
  height: 40px;
  text-align: center;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  overflow: hidden;
}
.reade .el-tabs__item {
  font-size: 14px;
  height: 40px;
  text-align: center;
  padding-left: 0;
  width: 50%;
}

.reade .el-tabs__active-bar {
  height: 0;
  width: 50%;
  background: #fff;
}
.reade .el-tabs__item:hover {
  color: #333;
}
.reade .el-tabs__item.is-active {
  color: #fff;
  padding-right: 0;
  background: #4e86ff;
}
.reade .el-tabs__nav-wrap::after {
  height: 0;
}
</style>
  <!---->
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "@/assets/css/clientSide/applicationRouting.scss";

.cur-detail {
  display: flex;
  position: relative;
  width: 100%;
  .app-detail-scrollbar {
    width: 100%;
  }
  .ctoAllArea-ai {
    position: relative;
    height: 100%;
    background: #fff;
    transition: width 0.1s;

    .resize-handle {
      position: absolute;
      left: 0;
      top: 0;
      width: 2px;
      height: 100%;
      z-index: 3;
      cursor: col-resize;
      background: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }

      &:active {
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
  .open-details-foot {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    position: absolute;
    bottom: 0;
    background-color: #fff;
    border-top: 1px solid #d8d8d8;
    box-shadow: 0px 0px 4px 0px rgba(189, 189, 189, 0.5);
    .footerBtn {
      margin-right: 10px;
    }
  }
}

:deep(.timeline-blue .el-timeline-item__icon) {
  color: #ffffff !important;
}
:deep(.el-form--label-top .el-form-item__label) {line-height: 20px;color: #333333;font-weight: bold;overflow: hidden;flex-wrap: wrap;white-space: nowrap;text-overflow: ellipsis;width:100%;}
:deep(.yes-buttom) {background: #19B359;color: white;border:1px solid transparent;}
:deep(.yes-buttom:hover) {background: #16A04F;}
:deep(.yes-buttom:active) {background: #16A04F;}
:deep(.el-dialog.is-fullscreen) {
  overflow: hidden;
}
.link-config {
  display: flex;
  align-content: center;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
  .link-config-title {
    padding-right: 10px;
  }
  .link-config-but {
    margin-right: 10px;
    cursor: pointer;
    &:last-child {
      margin-right: 0;
    }
    &:hover {
      color: #4ea6ff;
      text-decoration: underline;
    }
  }
}
.active-hover:hover {
  color: #4e86ff;
  i {
    color: #4e86ff;
  }
}

@keyframes flash {
  0%,
  100%,
  50% {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0.4;
  }
}
:deep(.application-routing-dialog-all .el-dialog__body) {
  padding: 0;
  width: 100%;
  height: 100%;
}
@keyframes move {
  to {
    background-position: 0 100%, 0 0, 0 0, 0 0;
    /* 终止位置 */
    clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
}
.drwaer {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: inline-block;
  .loader {
    border: 16px solid #f3f3f3;
    border-radius: 50%;
    border-top: 16px solid #3498db;
    width: 120px;
    height: 120px;
    -webkit-animation: spin 2s linear infinite;
    animation: spin 2s linear infinite;
    position: fixed;

    transform: translate(-50%, -50%);
    left: 44%;
    top: 38%;
  }

  .wrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 999;
    background: linear-gradient(#1a98ca, #1a98ca),
      linear-gradient(90deg, #ffffff33 1px, transparent 0, transparent 19px),
      linear-gradient(#ffffff33 1px, transparent 0, transparent 19px),
      linear-gradient(transparent, #1a98ca);
    background-size: 100% 1.5%, 10% 100%, 100% 8%, 100% 100%;
    background-repeat: no-repeat, repeat, repeat, no-repeat;
    background-position: 0% 0%, 0 0, 0 0, 0 0;
    /* 初始位置 */
    clip-path: polygon(0% 0%, 100% 0%, 100% 1.5%, 0% 1.5%);
    /* 添加动画效果 */
    animation: move 2s infinite linear;
  }
}
.blockDiaCont {
  width: 100%;
  height: 93%;
}

.oaExamineLeft {
  // flex: 4;
  height: 100%;
  display: inline-block;
  position: relative;
  vertical-align: top;
  .oaExamineAuditBox {
    width: 100%;
    height: calc(100% - 40px);
  }
}
.app-name-class2 {
  padding-left: 25px;
  height: auto;
  color: #000;
  font-size: 32px;
  margin-top: 10px;
  font-weight: bold;
}
.oaExamineRight {
  // flex: 1.5;
  width: 26%;
  // height: 100%;
  display: inline-block;
  border-left: 1px solid #d8d8d8;
  vertical-align: top;
  .ctoArray-class {
    width: 100%;
    height: 100%;
  }
  .ctoArray-class p.title {
    margin: 0 15px;
    height: 44px;
    color: #333;
    line-height: 44px;
    border-bottom: 1px solid #e2e0dc;
  }
}
.oaExamineAllArea {
  width: 100%;
  display: flex;
  position: absolute;
  .ctoAllArea-ai {
    position: relative;
    height: 100%;
    background: #fff;
    transition: width 0.1s;

    .resize-handle {
      position: absolute;
      left: 0;
      top: 0;
      width: 2px;
      height: 100%;
      z-index: 3;
      cursor: col-resize;
      background: transparent;

      &:hover {
        background: rgba(0, 0, 0, 0.1);
      }

      &:active {
        background: rgba(0, 0, 0, 0.2);
      }
    }
  }
}
  .ctoAllArea-flow {
  width: 100%;
  .timeline- {
    :deep(.el-timeline-item__wrapper) {
        opacity: 0.4;
    }
  }
  :deep(.el-timeline) {
    font-size: 14px !important;
    .el-timeline-item {
      padding-bottom: 24px;
      .el-card.is-always-shadow {
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      }
    }
  }
  :deep(.el-timeline-item__tail) {
    top: 32px;
    height: calc(100% - 37px);
    left: 11px;
    border-color: #D9D9D9;
  }
  :deep(.el-timeline-item__node) {
    width: 24px;
    height: 24px;
    top: 0;
    background-color: #fff;
    border: 2px solid #F2F3F5;
    border-radius: 50%;
  }
  :deep(.el-timeline-item__wrapper) {
    padding-left: 36px;
  }
  .timeline-primary {
    border-color: #5B85F7;
    :deep(.el-timeline-item__node) {
      border-color: #5B85F7;
    }
    :deep(.el-timeline-item__tail) {
      border-color: #5B85F7;
    }
  }
  .timeline-success {
    border-color: #5B85F7;
    :deep(.el-timeline-item__node) {
      border-color: #5B85F7;
      background-color: #5B85F7;
      .el-timeline-item__icon {
        color: #ffffff;
        font-size: 16px;
        font-weight: bold;
      }
    }
    :deep(.el-timeline-item__tail) {
      border-color: #5B85F7;
    }
  }
  .timeline-end {
    :deep(.el-timeline-item__node) {
      border-color: #5B85F7;
      .icon-end {
        width: 14px;
        height: 14px;
        background-color: #5B85F7;
        border-radius: 50%;
      }
    }
  }
  .orgname span {
    background-color: #FEF9EA;
    color: #F09137;
  }
  .AuditList-head {
    display: flex;
    align-items: center;
    width: 100%;
    margin-top: 10px;
    max-width: inherit;
    .sponsor {
      color: #E7C576;
    }
    .time {
      color: #0000005a;
      font-weight: 400;
      font-size: 14px;
      padding-left: 5px;
      i {
        font-size: 14px;
        color: #0000005a;
        margin-right: 5px;
      }
    }
    .blueBtn {
      margin-left: 3px;
      margin-right: 5px;
      i {
        font-size: 12px;
      }
    }
    .def-d {
      color: #000000;
      font-weight: bold;
      font-size: 16px;
    }
  }
  .comment-class {
    margin-top: 15px;
    padding: 8px 7px;
    background-color: #F4F4F48a;
    color: #34393D8a;
      font-weight: 400;
      font-size: 14px;
      border-radius: 4px;
    }
    .urgent-class {
      .blueBtn {
        border-radius: 4px;
        border: 1px solid #5B85F7;
        padding: 0 7px;
        color: #5B85F7;
        font-size: 16px;
      }
    }
  }

.icon-timeLine-user {
  position: absolute;
  left: 20px;
  top: 14px;
  font-size: 18px;
  color: #42a5f5;
}
.dialog-header {
  background: #4e86ff;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  color: #fff;
  overflow: hidden;
  text-align: center;
  line-height: 60px;
  display: inline-block;
  vertical-align: middle;
}
.dialog-name {
  display: inline-block;
  /*width: 380px;*/
  padding-left: 10px;
  vertical-align: middle;
}

.my-autocomplete .el-input--suffix .el-input__inner {
  border: none;
  border-top: 1px solid #dcdfe6;
  border-radius: 0;
}
.close-dialog {
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 9;
  cursor: pointer;
  i {
    color: #575B66;
    font-size: 20px;
  }
  &:hover i {
    color: #4e86ff;
  }
}
.form-main-class .col_key {
  width: 128px;
  font-size: 15px;
  color: #6c3d00;
  margin-bottom: 6px;
  text-align: left;
  vertical-align: top;
  display: inline-block;
}
.form-main-class .col_key.label-class {
  width: 100%;
}
.form-main-class .textarea-class-wrap .col_value {
  width: 900px;
  line-height: 26px;
}
.form-main-class .col_value {
  width: 400px;
  font-size: 15px;
  display: inline-block;
  word-wrap: break-word;
  word-break: break-all;
  padding-top: 0px;
  color: #000;
}
.form-main-class .col_value.rel-userclass span {
  height: 27px;
  line-height: 27px;
  padding: 0px 8px;
  display: inline-block;
  margin-right: 8px;
  color: #333333;
  background-color: #d7ebff;
  border-radius: 4px;
}
.form-main-class .col_value.rel-userclass span:last-child:after {
  content: "";
}
.form-main-class .file-class .col_value span {
  width: 100%;
}
.dialognewclass .el-dialog__title {
  color: #000000;
  font-size: 16px;
}

.inform {
  font-size: 18px;
  color: #965500;
  padding-left: 35px;
  padding-right: 22px;
  padding-top: 39px;
}
.inform-number {
  font-size: 14px;
  color: #965500;
  cursor: pointer;
}
.examine-footer {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  height: 40px;
  overflow: hidden;
  z-index: 8; //待我办理明细序号的z-index:8（明细涉及的很多，不敢改所以先改这里）会盖住常用语，所以先加上 hj 2025.05.06
  // z-index: 111;
  background: #f7f7f7;
  border-top: 1px solid #d8d8d8;
  text-align: right;
  .footer-box {
    width: 100%;
    height: 40px;
    line-height: 36px;
    padding: 10px 0;
    font-size: 16px;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(189, 189, 189, 0.5);
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    .footerBtn {
      display: inline-block;
      vertical-align: middle;
      margin: -1px 10px 0 0;
      font-size: 12px;
      cursor: pointer;
    }
    .fiexd-canvas-bottom {
      margin: 0 auto;
      padding: 10px 0;
      display: flex;
      justify-content: center;
      background-color: #fff;
      .disabled-btn, .clickable-btn {
        width: 160px;
        border-radius: 4px;
        line-height: 40px;
        text-align: center;
        margin-left: 40px;
        cursor: pointer;
      }
      .disabled-btn {
        color: #999999;
        background-color: #EEEEEE;
      }
      .clickable-btn {
        color: #FFFEFF;
        background: linear-gradient(90deg, rgba(52, 165, 254, 1) 0%, rgba(97, 132, 245, 1) 100%);
      }
    }
  }
}
.auditBox {
  position: relative;
  /* padding-bottom: 10px; */
}
.auditBox .statrs {
  position: absolute;
  top: 40px;
  right: 30px;
  z-index: 111;
}
.top-class {
  .rigntBtn {
    i {
      margin-right: 3px;
      display: inline-block;
    }
    p {
      display: inline-block;
    }
    .collect {
      margin-right: 16px;
      cursor: pointer;
      .collection {
        color: #ffbf00;
      }
      .icon-shoucang-mian {
        color: #ffbf00;
      }
    }
    .ballShow {
      width: 10px;
      height: 10px;
      border-radius: 50%;
      box-shadow: 0px 0px 12px rgba(25, 176, 89, 1);
      background-color: #19b359;
      animation-duration: 2.5s;
      animation-fill-mode: both;
      animation-iteration-count: infinite;
      animation-name: flash;
      display: inline-block;
      vertical-align: top;
      margin-top: 17px;
      margin-right: 4px;
      &.red {
        box-shadow: 0px 0px 12px rgba(255, 64, 88, 1);
        background-color: #ff4058;
      }
    }
  }
}
:deep(.el-icon-circle-close:before) {
  color: white;
}

.fRight .status-class {
  display: inline-block;
  color: #333333;
  border-radius: 15px;
  line-height: normal;
  padding: 1px 10px;
  border: 1px dashed #d9c7c7;
  display: inline-block;
  margin: 6px 0px;
}
.fRight .status-class i {
  margin-right: 3px;
  vertical-align: middle;
}
.AuditList-head {
  font-weight: bold;
  margin-top: 5px;
}
.AuditList-head span.sponsor {
  color: #f2ab02;
}
.AuditList-head span.flow {
  color: #965500;
}
.AuditList-head span.success {
  color: #19b359;
}
.AuditList-head span.pass {
  color: #d0021b;
}
.AuditList-head span.recall {
  color: #999;
}
.AuditList-head span.yellow {
  color: #4358d2;
}
.AuditList-head .span-text {
  font-weight: normal;
  color: #999999;
}
.AuditList-head .approval-stat {
  color: #965500;
}
.qrcode {
  cursor: pointer;
  font-size: 16px;
}
.approuser {
  padding-top: 4px;
}
.approuser span {
  background: #ccc;
  color: #fff;
  padding: 1px 8px;
  margin: 0 3px;
  font-size: 12px;
  display: inline-block;
}
.readeClass {
  overflow: hidden;
  padding: 0 15px;
}
.readeClass li {
  float: left;
  font-size: 14px;
  width: 50%;
}
.readeClass li.user::before {
  font-family: "iconfont" !important;
  vertical-align: middle;
  color: #3aa7e1;
  font-size: 16px;
  content: "\e68e";
}
.readeClass li.org::before {
  font-family: "iconfont" !important;
  vertical-align: middle;
  color: #3faf67;
  font-size: 16px;
  content: "\e67d";
}
.readeClass li span {
  display: inline-block;
  vertical-align: middle;
  margin: 12px 3px;
  color: #666;
  padding: 2px 8px;
  background: #f4f3f3;
  max-width: 100px;
}
.readeClass li span:nth-child(1) {
  background: none;
  color: #333;
}
.readeClass li span .iconfont {
  padding-right: 4px;
  font-size: 18px;
}

/*常用语添加*/
.fastReplyUl {
  border-top: 1px solid #f2f2f2;
}
.dynamicValidate {
  height: 400px;
  overflow: auto;
}
.fastReplySub {
  width: 100%;
  color: #4e86ff;
  border: 1px dashed #ccc;
}
.to ul.mode-cto-class {
  padding: 15px;
}
.to ul.mode-cto-class li {
  width: 50%;
  padding-bottom: 10px;
  margin-bottom: 15px;
  border-bottom: 1px solid #dcdcdc;
  float: left;
  position: relative;
}
.to ul li .headPortrait {
  display: inline-block;
  width: 50px;
  height: 50px;
  overflow: hidden;
  vertical-align: middle;
  border-radius: 50%;
  background: #f5ad00;
  text-align: center;
  color: #fff;
  line-height: 50px;
}
.to ul.mode-cto-class li .name {
  width: auto;
  min-width: 25%;
  border-bottom: solid 1px #dcdcdc;
  display: inline-block;
  vertical-align: middle;
  padding-left: 16px;
  padding-bottom: 0px;
  border-bottom: none;
  max-width: 80%;
}
.to ul.mode-cto-class li .name span {
  background: #ececec;
  border-radius: 4px;
  color: #666666;
  margin: 0 4px;
  padding: 2px 3px;
}

.blueBtn {
  /* text-decoration: underline; */
  color: #4284ba;
  cursor: pointer;
  .icon-a-zu181 {
    font-size: 10px;
    margin-right: 12px;
  }
}
.comment-class {
  color: #333;
  position: relative;
}
.sign-class {
  color: #333;
  position: relative;
  display: flex;
  align-items: center;
  img{
    width: 200px;
    height: 70px;
  }
}
.notefile-class {
  padding: 5px 0;
  color: #4e86ff;
  font-weight: bold;
  position: relative;
  cursor: pointer;
  p {
    display: inline-block;
    vertical-align: middle;
    width: 89%;
    &:hover {
      color: #2086da;
    }
    &.noteicon {
      width: 9%;
      text-align: center;
      a {
        text-decoration: none;
        color: #999;
        &:hover {
          color: #666;
        }
      }
    }
  }
}

.urgent-class {
  margin-top: 10px;
  .blueBtn {
    border: 1px dotted #69716e;
    border-radius: 20px;
    padding: 3px 10px;
  }
}

.process {
  overflow: hidden;
  // .el-row .el-col {
  //   padding: 5px 0;
  // }
  .name {
    font-weight: 400;
    display: flex;
    padding-right: 3px;
    font-size: 16px;
  }
}
// pc弹窗高度-自适应
:deep(.dialog-height-auto) {
  min-height: inherit;
  .oaExamineAllArea {
    position: inherit;
    .examine-footer {
      position: inherit;
    }
  }
}
:deep(.chat-path-dialog) {
    background: transparent;
    padding-top: 37px;
    .oaExamineAllArea{
      .ctoAllArea-ai {
        background: transparent;
        border: none;
          .resize-handle {
            display: none;
          }
      }
    }
}
.cto-list {
  width: calc(100% - 40px);
  margin: 0 auto;
  padding-bottom: 24px;
  .cto-row {
    background: #fff;
    .inner {
      display: flex;
      padding: 10px 0;
      .title {
        display: block;
        flex: 0 0 120px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }
      .list-detail {
        position: relative;
        flex: 1;
        min-width: 0;
        padding: 0 10px;
        .list-box {
          width: 100%;
          min-height: 32px;
          margin-left: -2px;
          clear: both;
          overflow: hidden;
          :deep(.el-tag) {
            float: left;
          }
          :deep(.choose-type1) {
            background: #FFE7E8;
            color: #FC6D70 !important;
            padding:2px 5px;
            border-radius: 2px;
            margin-left: 5px;
          }
          :deep(.choose-type2) {
            background: #FFEADB;
            color: #FB851C !important;
            padding:2px 5px;
            border-radius: 2px;
            margin-left: 5px;
          }
        }
        .blueBtn {
          display: inline-block;
          height: 40px;
          line-height: 40px;
          color: #5086FF;
          font-size: 14px;
        }
        p {
          display: inline-block;
          color: #999999;
          height: 40px;
          line-height: 40px;
          font-size: 14px;
          line-height: 20px;
          padding-left: 10px;
        }
      }
    }
    .inner-layout {
      display: block;
      .title {
        width: 100%;
        height: 30px;
        line-height: 30px;
      }
      .blueBtn {
        height: 24px !important;
        line-height: 24px !important;
      }
    }
  }
}
.input-page {
  width: 100%;
  height: 100%;
  .input-page-container {
    min-height: 700px;
    border: none;
  }
}

</style>
